// import React, { useEffect, useState, memo, useCallback } from "react";
// import axios from "axios";
// import { getToken } from "../../utils/auth";
// import { useTranslation } from "react-i18next";
// import CONFIG from "../../config";
// import { maskEmail, maskUsername, maskFullName, maskPhone } from "../../utils/anonymizer";

// const PERMISSION_OPTIONS = [
//   { id: 'products', label: 'Products' },
//   { id: 'categories', label: 'Categories' },
//   { id: 'messages', label: 'Messages' },
//   { id: 'reviews', label: 'Reviews' },
//   { id: 'users', label: 'Users' },
//   { id: 'analytics', label: 'Analytics' },
//   { id: 'hero', label: 'Hero/Sliders' },
//   { id: 'about', label: 'About Us' },
//   { id: 'feedback', label: 'Feedback' },

//   { id: 'users.email', label: 'Show User Email' },
//   { id: 'users.created_at', label: 'Show User Created Date' },
//   { id: 'users.updated_at', label: 'Show User Updated Date' },
//   { id: 'categories.icon', label: 'Show Category Icon' },
//   { id: 'categories.is_featured', label: 'Show Category Featured Status' },
//   { id: 'logs.ip', label: 'Show Log IP Addresses' },
//   { id: 'logs.details', label: 'Show Log Details' },
//   { id: 'secrets.value', label: 'Show Secret Keys' },
//   { id: 'users.assign_profile', label: 'Assign Users to Store Profiles' },

//   { id: '*', label: 'Full Access (Super Admin)' },
// ];

// const AdminUsers = memo(() => {
//   const { t, i18n } = useTranslation();
//   const [users, setUsers] = useState([]);
//   const [profiles, setProfiles] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [q, setQ] = useState("");
//   const [form, setForm] = useState({ username: "", fullname: "", email: "", phone: "", password: "", isAdmin: false, is_master_admin: false, permissions: [], profile_id: '' });
//   const [message, setMessage] = useState("");

//   const [editingUser, setEditingUser] = useState(null);

//   const isArabic = i18n.language?.startsWith('ar');
//   const apiBase = `${CONFIG.API_URL}/api/admin/users`;

//   const [permissions, setPermissions] = useState([]);
//   const [isAdmin, setIsAdmin] = useState(false);
//   // Renamed from isMainApp to reflect that this check detects if the current logged-in user 
//   // has Master/Super privileges (*) and is therefore allowed to create other Master Admins.
//   const [isAdminWithMasterPrivileges, setIsAdminWithMasterPrivileges] = useState(false);
//   // isMainStoreAdmin: true if the current user is on the main store (master profile or no profile).
//   // Used to control visibility of profile assignment UI — hidden for hostname store admins.
//   const [isMainStoreAdmin, setIsMainStoreAdmin] = useState(false);

//   const [currentUserId, setCurrentUserId] = useState(null);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user") || "{}");
//     setIsAdmin(!!user.isAdmin);
//     setCurrentUserId(user.id);
//     setPermissions(user.permissions || []);
//     // Determine if we are running on the main app (master) by asking server stats.
//     (async () => {
//       try {
//         const token = getToken();
//         const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/stats`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
//         // isMaster = true only for global master admin (main store * admin)
//         setIsAdminWithMasterPrivileges(!!res.data?.isMaster);
//         // isMainStoreAdmin = true for any admin on the main store (master profile or no profile)
//         setIsMainStoreAdmin(!!res.data?.isMainStoreAdmin);
//       } catch (e) {
//         setIsAdminWithMasterPrivileges(false);
//         setIsMainStoreAdmin(false);
//       }
//     })();
//   }, []);

//   const hasPerm = (p) => {
//     if (!isAdmin) return false;
//     const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
//     // If this is NOT the main store context (indicated by having a profile assigned to self),
//     // and we are currently on a hostname-specific domain, restrict profile assignment features.
//     const isHostnameContext = !isAdminWithMasterPrivileges && !!currentUser.profile_id;
//     if (isHostnameContext && (p === 'users.assign_profile' || p === 'users.manage_profiles' || p === 'users.assign_profiles')) return false;

//     // Super admins (those with '*' or Master Privileges) always have full control.
//     if (isAdmin && (isAdminWithMasterPrivileges || !!currentUser.profile_id)) return true;

//     if (permissions.includes('*') || permissions === '*') return true;
//     return permissions.includes(p);
//   };

//   const getHeaders = useCallback(() => {
//     const token = getToken();
//     return token ? { Authorization: `Bearer ${token}` } : {};
//   }, []);

//   const fetchProfiles = useCallback(async () => {
//     try {
//       const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles`, { headers: getHeaders() });
//       setProfiles(res.data || []);
//     } catch (err) {
//       console.error('Failed to load profiles', err);
//     }
//   }, [getHeaders]);

//   const fetchUsers = useCallback(async (p = 1) => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${apiBase}?page=${p}&per=50&q=${encodeURIComponent(q)}`, { headers: getHeaders() });
//       setUsers(res.data.data || []);
//       setTotal(res.data.meta?.total || 0);
//       setPage(p);
//       setMessage(''); // Clear any previous error messages on success
//     } catch (err) {
//       console.error(err);
//       if (err.response?.status === 403) {
//         setMessage("Invalid Users Admin Secret. Access denied.");
//       } else {
//         setMessage(err.response?.data?.message || "Failed to load users");
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [apiBase, q, getHeaders]);

//   useEffect(() => { fetchUsers(); fetchProfiles(); }, [fetchUsers, fetchProfiles]);
//   useEffect(() => { fetchUsers(1); }, [q, fetchUsers]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setForm(prev => {
//       let next = { ...prev, [name]: type === 'checkbox' ? checked : value };

//       // LOGIC: If 'Make Master Admin' is checked, we MUST also check 'Make Admin'.
//       // A master admin cannot exist without being an administrator.
//       if (name === 'is_master_admin' && checked) {
//         next.isAdmin = true;
//       }

//       // If 'Make Admin' is unchecked while 'Master Admin' is still checked,
//       // we uncheck 'Master Admin' too to maintain logical consistency.
//       if (name === 'isAdmin' && !checked && prev.is_master_admin) {
//         next.is_master_admin = false;
//       }

//       return next;
//     });
//   };

//   const createUser = async (e) => {
//     e.preventDefault();
//     try {
//       let perms = [...(form.permissions || [])];

//       if (form.is_master_admin) {
//         // Master Admins get the global wildcard permission.
//         if (!perms.includes('*')) perms.push('*');
//       } else if (form.isAdmin) {
//         // BUG FIX: For standard admins (not master), ensure they don't get "None" permissions.
//         // We assign a baseline set of standard management permissions by default.
//         const defaultAdminPerms = ['products', 'categories', 'messages', 'reviews', 'hero', 'about', 'feedback'];
//         defaultAdminPerms.forEach(p => {
//           if (!perms.includes(p)) perms.push(p);
//         });
//       }

//       const payload = { ...form, permissions: perms, isAdmin: form.isAdmin || form.is_master_admin };
//       await axios.post(apiBase, payload, { headers: getHeaders() });
//       setForm({ username: "", fullname: "", email: "", phone: "", password: "", isAdmin: false, is_master_admin: false, permissions: [], profile_id: '' });
//       setMessage("User created successfully!");
//       fetchUsers();
//     } catch (err) {
//       console.error(err);
//       setMessage(err.response?.data?.message || "Create failed");
//     }
//   };

//   const toggleAdmin = async (id, currentIsAdmin) => {
//     // Basic toggle. If making admin, permissions start empty.
//     const userToUpdate = users.find(u => u.id === id);
//     if (currentIsAdmin) {
//       const adminCount = users.filter(u => u.isAdmin).length;
//       if (adminCount <= 1 && userToUpdate.permissions?.includes('*')) {
//         // Primitive check to prevent removing last super admin
//         alert(t('admin.users_page.cannot_remove_last_admin', 'Cannot remove the last admin'));
//         return;
//       }
//     }

//     try {
//       await axios.put(`${apiBase}/${id}/role`, { isAdmin: !currentIsAdmin, permissions: [] }, { headers: getHeaders() });
//       fetchUsers();
//     } catch (err) {
//       console.error(err);
//       setMessage("Update failed");
//     }
//   };

//   const deleteUser = async (id) => {
//     const userToDelete = users.find(u => u.id === id);
//     if (userToDelete?.isAdmin) {
//       const adminCount = users.filter(u => u.isAdmin).length;
//       if (adminCount <= 1) {
//         alert(t('admin.users_page.cannot_delete_last_admin', 'Cannot delete the last admin'));
//         return;
//       }
//     }

//     const confirmMessage = userToDelete?.isAdmin ? "Delete this admin?" : "Delete this user?";
//     if (!window.confirm(confirmMessage)) return;
//     try {
//       await axios.delete(`${apiBase}/${id}`, { headers: getHeaders() });
//       fetchUsers();
//     } catch (err) {
//       console.error(err);
//       setMessage(err.response?.data?.message || "Delete failed");
//     }
//   };

//   // -- Permission Modal Logic --
//   const openPermissionModal = (user) => {
//     let perms = [];
//     if (Array.isArray(user.permissions)) perms = user.permissions;
//     else if (typeof user.permissions === 'string') {
//       try { perms = JSON.parse(user.permissions); } catch (e) { }
//     }
//     setEditingUser({ ...user, fullname: user.fullname || '', phone: user.phone || '', permissions: perms, profile_id: user.profile_id || '' });
//   };

//   const handlePermissionChange = (permId) => {
//     if (!editingUser) return;

//     // Prevent self-demotion from Super Admin
//     if (permId === '*' && editingUser.id === currentUserId && editingUser.permissions.includes('*')) {
//       alert("You cannot remove your own 'Full Access' permission to prevent accidental lockout.");
//       return;
//     }

//     let newPerms = [...(editingUser.permissions || [])];

//     if (permId === '*') {
//       // If selecting Full Access, clear others? Or just toggle?
//       // Let's say if we toggle *, we add/remove it.
//       if (newPerms.includes('*')) newPerms = newPerms.filter(p => p !== '*');
//       else newPerms = ['*']; // Exclusive? Or just include? Let's make it exclusive for cleanliness
//     } else {
//       // If * exists, remove it if we selecting specific? 
//       // Implementation choice: If * is present, usually implies everything. 
//       // If we uncheck *, we go back to nothing.
//       if (newPerms.includes('*')) newPerms = [];

//       if (newPerms.includes(permId)) {
//         newPerms = newPerms.filter(p => p !== permId);
//       } else {
//         newPerms.push(permId);
//       }
//     }
//     setEditingUser({ ...editingUser, permissions: newPerms });
//   };

//   const savePermissions = async () => {
//     if (!editingUser) return;
//     try {
//       // CONSOLIDATED UPDATE: We send isAdmin, permissions, and profile_id in a single request.
//       // This is more efficient and avoids potential race conditions or partial saves.
//       await axios.put(`${apiBase}/${editingUser.id}`, {
//         username: editingUser.username,
//         fullname: editingUser.fullname,
//         phone: editingUser.phone,
//         isAdmin: true, // If we are editing permissions, they are implicitly an admin.
//         permissions: editingUser.permissions,
//         profile_id: editingUser.profile_id
//       }, { headers: getHeaders() });

//       setEditingUser(null);
//       fetchUsers();
//       setMessage("Permissions & profile updated successfully!");
//     } catch (err) {
//       console.error(err);
//       setMessage(err.response?.data?.message || "Failed to update permissions");
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     return new Date(dateString).toLocaleDateString(i18n.language, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
//   };


//   return (
//     <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
//       <div className="flex items-center justify-between mb-12">
//         <h2 className="text-4xl font-black text-gray-900 tracking-tight">{t('admin.users_page.title')}</h2>
//         <div className="flex items-center gap-4">
//           <button
//             onClick={() => window.history.back()}
//             className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all"
//           >
//             <span className={`inline-block transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>←</span>
//             {t('admin.common.back', 'Back')}
//           </button>
//         </div>
//       </div>

//       <div className="bg-brand-primary/5 p-8 rounded-[30px] border border-brand-primary/10 mb-8">
//         <h3 className="font-bold text-gray-900 mb-6 flex items-center gap-2">
//           <span className="w-8 h-8 rounded-full bg-brand-primary text-white flex items-center justify-center text-sm"><i className="fas fa-plus"></i></span>
//           {t('admin.users_page.create_new_user', 'Create New User')}
//         </h3>
//         <div className="flex flex-col md:flex-row items-end gap-4">
//           <form onSubmit={createUser} className="grid grid-cols-1 md:grid-cols-5 gap-4 flex-1 w-full">
//             <input name="username" value={form.username} onChange={handleChange} placeholder={t('admin.users_page.username_placeholder')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             <input name="fullname" value={form.fullname} onChange={handleChange} placeholder={t('admin.users_page.fullname_placeholder', 'Full Name')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             <input name="email" value={form.email} onChange={handleChange} placeholder={t('admin.users_page.email_placeholder')} type="email" className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             <input name="phone" value={form.phone} onChange={handleChange} placeholder={t('admin.users_page.phone_placeholder', 'Phone Number')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             <input name="password" value={form.password} onChange={handleChange} placeholder={t('admin.users_page.password_placeholder')} type="password" className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             {/* Assign Store Profile: Only shown for main-store admins (not hostname store admins) */}
//             {isMainStoreAdmin && (
//               <select name="profile_id" value={form.profile_id} onChange={handleChange} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium bg-white">
//                 <option value="">{t('admin.users_page.assign_profile_placeholder', 'Assign Store Profile...')}</option>
//                 {profiles
//                   .filter(p => p.hostname !== null || p.id === 'prof_01JK0000000000000000000001' || p.name === "Main Store Pack")
//                   .map(p => <option key={p.id} value={p.id}>{p.name}</option>)
//                 }
//               </select>
//             )}
//             <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm">
//               <input type="checkbox" name="isAdmin" checked={form.isAdmin} onChange={handleChange} className="w-5 h-5 accent-brand-primary" id="isAdminCheck" />
//               <label htmlFor="isAdminCheck" className="font-bold text-xs uppercase tracking-widest text-gray-600 cursor-pointer">{t('admin.users_page.make_admin')}</label>
//             </div>
//             {/* Feature Visibility: Only show the "Make Master Admin" option if the CURRENT user has Master privileges. */}
//             {isAdminWithMasterPrivileges && (
//               <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm border border-amber-100">
//                 <input type="checkbox" name="is_master_admin" checked={form.is_master_admin} onChange={handleChange} className="w-5 h-5 accent-amber-500" id="isMasterAdminCheck" />
//                 <label htmlFor="isMasterAdminCheck" className="font-bold text-[10px] uppercase tracking-widest text-amber-700 cursor-pointer">{t('admin.users_page.make_master_admin', 'Make Master Admin')}</label>
//               </div>
//             )}
//           </form>
//           <button onClick={createUser} className="bg-brand-primary text-white px-8 py-4 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-brand-primary/20 hover:scale-105 active:scale-95 transition-all self-stretch md:self-auto h-[56px] flex items-center justify-center">
//             {t('admin.users_page.create_btn')}
//           </button>
//         </div>
//       </div>

//       <div className="flex justify-between items-center mb-6 gap-4">
//         <div className="relative flex-1 max-w-md">
//           <i className="fas fa-search absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
//           <input value={q} onChange={e => setQ(e.target.value)} placeholder={t('admin.common.search_placeholder', 'Search by username, email, or ID...')} className="w-full pl-12 pr-4 py-3 rounded-2xl border-none bg-gray-50 focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-medium" />
//         </div>


//       </div>

//       {message && <div className="mb-6 p-4 bg-blue-50 text-blue-800 rounded-2xl font-medium border border-blue-100 flex items-center gap-3"><i className="fas fa-info-circle"></i>{message}</div>}

//       {
//         loading ? <div className="p-12 text-center text-gray-500 font-medium animate-pulse">{t('admin.common.loading')}</div> : (
//           <div className="overflow-x-auto rounded-[30px] border border-gray-100 shadow-sm">
//             <table className="w-full text-left">
//               <thead className="bg-gray-50 border-b border-gray-100 text-gray-500">
//                 <tr>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.common.id')}</th>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_username', 'Username')}</th>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_fullname', 'Full Name')}</th>
//                   {hasPerm('users.email') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_email')}</th>}
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_phone', 'Phone')}</th>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_admin')} / Role</th>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_permissions', 'Permissions')}</th>
//                   {isAdminWithMasterPrivileges && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_store_profile', 'Store Profile')}</th>}
//                   {hasPerm('users.created_at') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_created', 'Created')}</th>}
//                   {hasPerm('users.updated_at') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_updated', 'Updated')}</th>}
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest text-right">{t('admin.common.actions', 'Actions')}</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {users.map(u => (
//                   <tr key={u.id} className="hover:bg-gray-50/80 transition-colors group">
//                     <td className="p-5 font-bold text-gray-600">#{u.id}</td>
//                     <td className="p-5">
//                       <div className="font-bold text-gray-900">{u && maskUsername(u?.username)}</div>
//                       <div className="text-[10px] text-gray-400 font-medium">@{u && maskUsername(u?.username)}</div>
//                     </td>
//                     <td className="p-5 font-medium text-gray-900">{u ? maskFullName(u?.fullname) : <span className="text-gray-300 italic">None</span>}</td>
//                     {hasPerm('users.email') && <td className="p-5 font-medium text-gray-600">{u && maskEmail(u?.email)}</td>}
//                     <td className="p-5 font-bold text-brand-primary text-xs whitespace-nowrap">{u ? maskPhone(u?.phone) : <span className="text-gray-300">—</span>}</td>
//                     <td className="p-5">
//                       {/* ROLE DIFFERENTIATION:
//                           - MASTER ADMIN (amber)  = has '*' AND is on main store (no profile or master profile)
//                           - SUPER ADMIN (indigo)  = has '*' AND is on a hostname-specific store profile
//                           - ADMIN (purple)         = isAdmin, no '*'
//                           - USER (gray)            = not admin
//                       */}
//                       {u.isAdmin ? (
//                         u.permissions && (u.permissions.includes('*') || u.permissions === '*') ? (
//                           u.profile_id && u.profile_id !== 'prof_01JK0000000000000000000001' ? (
//                             <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-indigo-200">
//                               {t('admin.users_page.role_super_admin', 'SUPER ADMIN')}
//                             </span>
//                           ) : (
//                             <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-amber-200">
//                               {t('admin.users_page.role_master_admin', 'MASTER ADMIN')}
//                             </span>
//                           )
//                         ) : (
//                           <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
//                             {t('admin.users_page.role_admin', 'ADMIN')}
//                           </span>
//                         )
//                       ) : (
//                         <span className="bg-gray-100 text-gray-500 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
//                           {t('admin.users_page.role_user', 'USER')}
//                         </span>
//                       )}
//                     </td>
//                     <td className="p-5">
//                       {u.isAdmin &&
//                         <div className="text-xs text-gray-500">
//                           {u.permissions && (u.permissions.includes('*') || u.permissions === '*') ?
//                             <span className="text-brand-primary font-bold">{t('admin.users_page.full_access', 'Full Access')}</span> :
//                             (u.permissions?.length > 0 ? (Array.isArray(u.permissions) ? u.permissions.join(', ') : u.permissions) : t('admin.users_page.none', 'None'))
//                           }
//                         </div>
//                       }
//                     </td>
//                     {isAdminWithMasterPrivileges && (
//                       <td className="p-5">
//                         {u.profile_id ? (
//                           <div className="flex flex-col">
//                             <span className="text-xs font-bold bg-indigo-50 text-indigo-700 px-2 py-1 rounded-lg w-fit">
//                               {profiles.find(p => p.id === u.profile_id)?.name || `Profile #${u.profile_id}`}
//                             </span>
//                             <span className="text-[10px] text-gray-400 mt-1">{u.profile_id}</span>
//                           </div>
//                         ) : <span className="text-xs text-gray-400">—</span>}
//                       </td>
//                     )}
//                     {hasPerm('users.created_at') && <td className="p-5 text-xs text-gray-500 whitespace-nowrap">{formatDate(u.created_at)}</td>}
//                     {hasPerm('users.updated_at') && <td className="p-5 text-xs text-gray-500 whitespace-nowrap">{formatDate(u.updated_at)}</td>}
//                     <td className="p-5 text-right">
//                       <div className="flex gap-2 justify-end opacity-40 group-hover:opacity-100 transition-opacity">
//                         {u.isAdmin && (
//                           <button onClick={() => openPermissionModal(u)} className="w-8 h-8 rounded-full bg-blue-50 hover:bg-blue-500 hover:text-white text-blue-500 flex items-center justify-center transition-all" title={t('admin.users_page.edit_permissions', 'Edit Permissions')}>
//                             <i className="fas fa-key text-xs"></i>
//                           </button>
//                         )}
//                         <button onClick={() => toggleAdmin(u.id, !!u.isAdmin)} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-brand-primary hover:text-white text-gray-600 flex items-center justify-center transition-all" title={t('admin.users_page.toggle_role', 'Toggle Role')}>
//                           <i className="fas fa-user-shield text-xs"></i>
//                         </button>
//                         <button onClick={() => deleteUser(u.id)} className="w-8 h-8 rounded-full bg-red-50 hover:bg-red-500 hover:text-white text-red-500 flex items-center justify-center transition-all" title={t('admin.common.delete', 'Delete')}>
//                           <i className="fas fa-trash text-xs"></i>
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )
//       }
//       {
//         total > 50 && (
//           <div className="flex justify-center gap-4 items-center mt-8">
//             <button onClick={() => fetchUsers(Math.max(1, page - 1))} disabled={page <= 1} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center disabled:opacity-50 transition-all font-bold">{isArabic ? "→" : "←"}</button>
//             <div className="text-xs font-black uppercase tracking-widest text-gray-400">{t('admin.common.page', { current: page, total: Math.ceil(total / 50) })}</div>
//             <button onClick={() => fetchUsers(page + 1)} disabled={page >= Math.ceil(total / 50)} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center disabled:opacity-50 transition-all font-bold">{isArabic ? "←" : "→"}</button>
//           </div>
//         )
//       }

//       {/* Permission Modal */}
//       {editingUser && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
//           <div className="bg-white p-8 rounded-[30px] shadow-2xl max-w-lg w-full m-4">
//             <h3 className="text-xl font-bold mb-4">Edit — {editingUser.username}</h3>

//             <div className="grid grid-cols-2 gap-4 mb-6">
//               <div>
//                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_username', 'Username')}</label>
//                 <input
//                   value={editingUser.username || ''}
//                   onChange={e => setEditingUser({ ...editingUser, username: e.target.value })}
//                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
//                 />
//               </div>
//               <div>
//                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_fullname', 'Full Name')}</label>
//                 <input
//                   value={editingUser.fullname || ''}
//                   onChange={e => setEditingUser({ ...editingUser, fullname: e.target.value })}
//                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
//                 />
//               </div>
//               <div className="col-span-2">
//                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_phone', 'Phone Number')}</label>
//                 <input
//                   value={editingUser.phone || ''}
//                   onChange={e => setEditingUser({ ...editingUser, phone: e.target.value })}
//                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
//                 />
//               </div>
//             </div>

//             {/* Assign to Store Profile: Only for main-store admins, hidden for hostname store admins */}
//             {isMainStoreAdmin && (
//               <div className="mb-6 p-4 bg-indigo-50 rounded-2xl border border-indigo-100">
//                 <label className="block text-xs font-black text-indigo-600 uppercase tracking-widest mb-2">🏪 {t('admin.users_page.assign_to_profile', 'Assign to Store Profile')}</label>
//                 <select
//                   value={editingUser.profile_id || ''}
//                   onChange={e => setEditingUser({ ...editingUser, profile_id: e.target.value })}
//                   className="w-full p-3 rounded-xl border border-indigo-200 bg-white font-medium text-sm focus:ring-2 focus:ring-indigo-300 outline-none"
//                 >
//                   <option value="">— {t('admin.users_page.no_profile_assigned', 'No profile assigned')} —</option>
//                   {profiles
//                     .filter(p => p.hostname !== null || p.id === 'prof_01JK0000000000000000000001' || p.name === "Main Store Pack" || p.id === editingUser.profile_id)
//                     .map(p => (
//                       <option key={p.id} value={p.id}>{p.name}{p.is_active ? ` ★ ${t('admin.users_page.primary', 'Primary')}` : ''}</option>
//                     ))
//                   }
//                 </select>
//                 <p className="text-[10px] text-indigo-400 mt-1 font-medium">{t('admin.users_page.profile_desc', 'This determines which isolated store this admin manages.')}</p>
//               </div>
//             )}

//             <div className="flex flex-col gap-2 mb-6 max-h-[40vh] overflow-y-auto">
//               {PERMISSION_OPTIONS.map(opt => {
//                 // Security: Hide profile assignment permission from non-Main-Store Admins
//                 if (opt.id === 'users.assign_profile' && !isMainStoreAdmin) return null;

//                 return (
//                   <React.Fragment key={opt.id}>
//                     {/* Visual separator before the Full Access option */}
//                     {opt.id === '*' && (
//                       <div className="my-2 border-t border-gray-100 pt-2" />
//                     )}
//                     <label className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer border transition-colors ${opt.id === '*' ? 'hover:bg-amber-50 hover:border-amber-200 border-transparent' : 'hover:bg-gray-50 border-transparent hover:border-gray-100'}`}>
//                       <input
//                         type="checkbox"
//                         checked={editingUser.permissions && editingUser.permissions.includes(opt.id)}
//                         onChange={() => handlePermissionChange(opt.id)}
//                         disabled={opt.id === '*' && editingUser.id === currentUserId}
//                         className={`w-5 h-5 ${opt.id === '*' ? 'accent-amber-500' : 'accent-brand-primary'} disabled:opacity-50 disabled:cursor-not-allowed`}
//                       />
//                       <span className={`font-medium ${opt.id === '*' ? 'text-amber-700' : 'text-gray-700'}`}>
//                         {opt.label}
//                       </span>
//                     </label>
//                   </React.Fragment>
//                 );
//               })}
//             </div>
//             <div className="flex gap-3 justify-end">
//               <button onClick={() => setEditingUser(null)} className="px-6 py-3 rounded-xl bg-gray-100 font-bold text-gray-600 hover:bg-gray-200">Cancel</button>
//               <button onClick={savePermissions} className="px-6 py-3 rounded-xl bg-brand-primary font-bold text-white hover:bg-brand-primary/90">Save</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div >
//   );
// });

// export default AdminUsers;












// // import React, { useEffect, useState, memo, useCallback } from "react";
// // import axios from "axios";
// // import { getToken } from "../../utils/auth";
// // import { useTranslation } from "react-i18next";
// // import CONFIG from "../../config";

// // const PERMISSION_OPTIONS = [
// //   { id: 'products', label: 'Products' },
// //   { id: 'categories', label: 'Categories' },
// //   { id: 'messages', label: 'Messages' },
// //   { id: 'reviews', label: 'Reviews' },
// //   { id: 'users', label: 'Users' },
// //   { id: 'analytics', label: 'Analytics' },
// //   { id: 'hero', label: 'Hero/Sliders' },
// //   { id: 'about', label: 'About Us' },
// //   { id: 'feedback', label: 'Feedback' },

// //   { id: 'users.email', label: 'Show User Email' },
// //   { id: 'users.created_at', label: 'Show User Created Date' },
// //   { id: 'users.updated_at', label: 'Show User Updated Date' },
// //   { id: 'categories.icon', label: 'Show Category Icon' },
// //   { id: 'categories.is_featured', label: 'Show Category Featured Status' },
// //   { id: 'logs.ip', label: 'Show Log IP Addresses' },
// //   { id: 'logs.details', label: 'Show Log Details' },
// //   { id: 'secrets.value', label: 'Show Secret Keys' },
// //   { id: 'users.assign_profile', label: 'Assign Users to Store Profiles' },

// //   { id: '*', label: 'Full Access (Super Admin)' },
// // ];

// // const AdminUsers = memo(() => {
// //   const { t, i18n } = useTranslation();
// //   const [users, setUsers] = useState([]);
// //   const [profiles, setProfiles] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [page, setPage] = useState(1);
// //   const [total, setTotal] = useState(0);
// //   const [q, setQ] = useState("");
// //   const [form, setForm] = useState({ username: "", fullname: "", email: "", phone: "", password: "", isAdmin: false, is_master_admin: false, is_super_admin: false, permissions: [], profile_id: '' });
// //   const [message, setMessage] = useState("");

// //   const [editingUser, setEditingUser] = useState(null);

// //   const isArabic = i18n.language?.startsWith('ar');
// //   const apiBase = `${CONFIG.API_URL}/api/admin/users`;

// //   const [permissions, setPermissions] = useState([]);
// //   const [isAdmin, setIsAdmin] = useState(false);
// //   // Renamed from isMainApp to reflect that this check detects if the current logged-in user 
// //   // has Master/Super privileges (*) and is therefore allowed to create other Master Admins.
// //   const [isAdminWithMasterPrivileges, setIsAdminWithMasterPrivileges] = useState(false);
// //   // isMainStoreAdmin: true if the current user is on the main store (master profile or no profile).
// //   // Used to control visibility of profile assignment UI — hidden for hostname store admins.
// //   const [isMainStoreAdmin, setIsMainStoreAdmin] = useState(false);

// //   const [currentUserId, setCurrentUserId] = useState(null);

// //   useEffect(() => {
// //     const user = JSON.parse(localStorage.getItem("user") || "{}");
// //     setIsAdmin(!!user.isAdmin);
// //     setCurrentUserId(user.id);
// //     setPermissions(user.permissions || []);
// //     // Determine if we are running on the main app (master) by asking server stats.
// //     (async () => {
// //       try {
// //         const token = getToken();
// //         const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/stats`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
// //         // isMaster = true only for global master admin (main store * admin)
// //         setIsAdminWithMasterPrivileges(!!res.data?.isMaster);
// //         // isMainStoreAdmin = true for any admin on the main store (master profile or no profile)
// //         setIsMainStoreAdmin(!!res.data?.isMainStoreAdmin);
// //       } catch (e) {
// //         setIsAdminWithMasterPrivileges(false);
// //         setIsMainStoreAdmin(false);
// //       }
// //     })();
// //   }, []);

// //   const hasPerm = (p) => {
// //     if (!isAdmin) return false;
// //     const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
// //     // If this is NOT the main store context (indicated by having a profile assigned to self),
// //     // and we are currently on a hostname-specific domain, restrict profile assignment features.
// //     const isHostnameContext = !isAdminWithMasterPrivileges && !!currentUser.profile_id;
// //     if (isHostnameContext && (p === 'users.assign_profile' || p === 'users.manage_profiles' || p === 'users.assign_profiles')) return false;

// //     // Super admins (those with '*' or Master Privileges) always have full control.
// //     if (isAdmin && (isAdminWithMasterPrivileges || !!currentUser.profile_id)) return true;

// //     if (permissions.includes('*') || permissions === '*') return true;
// //     return permissions.includes(p);
// //   };

// //   const getHeaders = useCallback(() => {
// //     const token = getToken();
// //     return token ? { Authorization: `Bearer ${token}` } : {};
// //   }, []);

// //   const fetchProfiles = useCallback(async () => {
// //     try {
// //       const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles`, { headers: getHeaders() });
// //       setProfiles(res.data || []);
// //     } catch (err) {
// //       console.error('Failed to load profiles', err);
// //     }
// //   }, [getHeaders]);

// //   const fetchUsers = useCallback(async (p = 1) => {
// //     setLoading(true);
// //     try {
// //       const res = await axios.get(`${apiBase}?page=${p}&per=50&q=${encodeURIComponent(q)}`, { headers: getHeaders() });
// //       setUsers(res.data.data || []);
// //       setTotal(res.data.meta?.total || 0);
// //       setPage(p);
// //     } catch (err) {
// //       console.error(err);
// //       if (err.response?.status === 403) {
// //         setMessage("Invalid Users Admin Secret. Access denied.");
// //       } else {
// //         setMessage(err.response?.data?.message || "Failed to load users");
// //       }
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [apiBase, q, getHeaders]);

// //   useEffect(() => { fetchUsers(); fetchProfiles(); }, [fetchUsers, fetchProfiles]);
// //   useEffect(() => { fetchUsers(1); }, [q, fetchUsers]);

// //   const handleChange = (e) => {
// //     const { name, value, type, checked } = e.target;

// //     setForm(prev => {
// //       let next = { ...prev, [name]: type === 'checkbox' ? checked : value };

// //       // Master Admin requires isAdmin
// //       if (name === 'is_master_admin' && checked) {
// //         next.isAdmin = true;
// //         next.is_super_admin = false; // mutually exclusive
// //       }

// //       // Super Admin requires isAdmin
// //       if (name === 'is_super_admin' && checked) {
// //         next.isAdmin = true;
// //         next.is_master_admin = false; // mutually exclusive
// //       }

// //       // If 'Make Admin' is unchecked, uncheck both elevated roles
// //       if (name === 'isAdmin' && !checked) {
// //         next.is_master_admin = false;
// //         next.is_super_admin = false;
// //       }

// //       return next;
// //     });
// //   };

// //   const createUser = async (e) => {
// //     e.preventDefault();
// //     try {
// //       let perms = [...(form.permissions || [])];
// //       const isHostnameProfile = form.profile_id && form.profile_id !== 'prof_01JK0000000000000000000001';

// //       if (form.is_master_admin) {
// //         if (!perms.includes('*')) perms.push('*');
// //         // For hostname profiles: add 'master' marker so the badge shows MASTER ADMIN (amber)
// //         // For no-profile / main profile: 'master' marker is not needed (profile_id already identifies them)
// //         if (isHostnameProfile && !perms.includes('master')) perms.push('master');
// //       } else if (form.is_super_admin) {
// //         // Super Admin: wildcard only, no 'master' marker → SUPER ADMIN (indigo) badge for hostname profiles
// //         if (!perms.includes('*')) perms.push('*');
// //       } else if (form.isAdmin) {
// //         // Standard admin: baseline permissions
// //         const defaultAdminPerms = ['products', 'categories', 'messages', 'reviews', 'hero', 'about', 'feedback'];
// //         defaultAdminPerms.forEach(p => {
// //           if (!perms.includes(p)) perms.push(p);
// //         });
// //       }

// //       const payload = { ...form, permissions: perms, isAdmin: form.isAdmin || form.is_master_admin || form.is_super_admin };
// //       await axios.post(apiBase, payload, { headers: getHeaders() });
// //       setForm({ username: "", fullname: "", email: "", phone: "", password: "", isAdmin: false, is_master_admin: false, is_super_admin: false, permissions: [], profile_id: '' });
// //       setMessage("User created successfully!");
// //       fetchUsers();
// //     } catch (err) {
// //       console.error(err);
// //       setMessage(err.response?.data?.message || "Create failed");
// //     }
// //   };

// //   const toggleAdmin = async (id, currentIsAdmin) => {
// //     // Basic toggle. If making admin, permissions start empty.
// //     const userToUpdate = users.find(u => u.id === id);
// //     if (currentIsAdmin) {
// //       const adminCount = users.filter(u => u.isAdmin).length;
// //       if (adminCount <= 1 && userToUpdate.permissions?.includes('*')) {
// //         // Primitive check to prevent removing last super admin
// //         alert(t('admin.users_page.cannot_remove_last_admin', 'Cannot remove the last admin'));
// //         return;
// //       }
// //     }

// //     try {
// //       await axios.put(`${apiBase}/${id}/role`, { isAdmin: !currentIsAdmin, permissions: [] }, { headers: getHeaders() });
// //       fetchUsers();
// //     } catch (err) {
// //       console.error(err);
// //       setMessage("Update failed");
// //     }
// //   };

// //   const deleteUser = async (id) => {
// //     const userToDelete = users.find(u => u.id === id);
// //     if (userToDelete?.isAdmin) {
// //       const adminCount = users.filter(u => u.isAdmin).length;
// //       if (adminCount <= 1) {
// //         alert(t('admin.users_page.cannot_delete_last_admin', 'Cannot delete the last admin'));
// //         return;
// //       }
// //     }

// //     const confirmMessage = userToDelete?.isAdmin ? "Delete this admin?" : "Delete this user?";
// //     if (!window.confirm(confirmMessage)) return;
// //     try {
// //       await axios.delete(`${apiBase}/${id}`, { headers: getHeaders() });
// //       fetchUsers();
// //     } catch (err) {
// //       console.error(err);
// //       setMessage(err.response?.data?.message || "Delete failed");
// //     }
// //   };

// //   // -- Permission Modal Logic --
// //   const openPermissionModal = (user) => {
// //     let perms = [];
// //     if (Array.isArray(user.permissions)) perms = user.permissions;
// //     else if (typeof user.permissions === 'string') {
// //       try { perms = JSON.parse(user.permissions); } catch (e) { }
// //     }
// //     setEditingUser({ ...user, fullname: user.fullname || '', phone: user.phone || '', permissions: perms, profile_id: user.profile_id || '' });
// //   };

// //   const handlePermissionChange = (permId) => {
// //     if (!editingUser) return;

// //     // Prevent self-demotion from Super Admin
// //     if (permId === '*' && editingUser.id === currentUserId && editingUser.permissions.includes('*')) {
// //       alert("You cannot remove your own 'Full Access' permission to prevent accidental lockout.");
// //       return;
// //     }

// //     let newPerms = [...(editingUser.permissions || [])];

// //     if (permId === '*') {
// //       // If selecting Full Access, clear others? Or just toggle?
// //       // Let's say if we toggle *, we add/remove it.
// //       if (newPerms.includes('*')) newPerms = newPerms.filter(p => p !== '*');
// //       else newPerms = ['*']; // Exclusive? Or just include? Let's make it exclusive for cleanliness
// //     } else {
// //       // If * exists, remove it if we selecting specific? 
// //       // Implementation choice: If * is present, usually implies everything. 
// //       // If we uncheck *, we go back to nothing.
// //       if (newPerms.includes('*')) newPerms = [];

// //       if (newPerms.includes(permId)) {
// //         newPerms = newPerms.filter(p => p !== permId);
// //       } else {
// //         newPerms.push(permId);
// //       }
// //     }
// //     setEditingUser({ ...editingUser, permissions: newPerms });
// //   };

// //   const savePermissions = async () => {
// //     if (!editingUser) return;
// //     try {
// //       // CONSOLIDATED UPDATE: We send isAdmin, permissions, and profile_id in a single request.
// //       // This is more efficient and avoids potential race conditions or partial saves.
// //       await axios.put(`${apiBase}/${editingUser.id}`, {
// //         username: editingUser.username,
// //         fullname: editingUser.fullname,
// //         phone: editingUser.phone,
// //         isAdmin: true, // If we are editing permissions, they are implicitly an admin.
// //         permissions: editingUser.permissions,
// //         profile_id: editingUser.profile_id
// //       }, { headers: getHeaders() });

// //       setEditingUser(null);
// //       fetchUsers();
// //       setMessage("Permissions & profile updated successfully!");
// //     } catch (err) {
// //       console.error(err);
// //       setMessage(err.response?.data?.message || "Failed to update permissions");
// //     }
// //   };

// //   const formatDate = (dateString) => {
// //     if (!dateString) return "-";
// //     return new Date(dateString).toLocaleDateString(i18n.language, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
// //   };


// //   return (
// //     <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
// //       <div className="flex items-center justify-between mb-12">
// //         <h2 className="text-4xl font-black text-gray-900 tracking-tight">{t('admin.users_page.title')}</h2>
// //         <div className="flex items-center gap-4">
// //           <button
// //             onClick={() => window.history.back()}
// //             className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all"
// //           >
// //             <span className={`inline-block transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>←</span>
// //             {t('admin.common.back', 'Back')}
// //           </button>
// //         </div>
// //       </div>

// //       <div className="bg-brand-primary/5 p-8 rounded-[30px] border border-brand-primary/10 mb-8">
// //         <h3 className="font-bold text-gray-900 mb-6 flex items-center gap-2">
// //           <span className="w-8 h-8 rounded-full bg-brand-primary text-white flex items-center justify-center text-sm"><i className="fas fa-plus"></i></span>
// //           {t('admin.users_page.create_new_user', 'Create New User')}
// //         </h3>
// //         <div className="flex flex-col md:flex-row items-end gap-4">
// //           <form onSubmit={createUser} className="grid grid-cols-1 md:grid-cols-5 gap-4 flex-1 w-full">
// //             <input name="username" value={form.username} onChange={handleChange} placeholder={t('admin.users_page.username_placeholder')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
// //             <input name="fullname" value={form.fullname} onChange={handleChange} placeholder={t('admin.users_page.fullname_placeholder', 'Full Name')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
// //             <input name="email" value={form.email} onChange={handleChange} placeholder={t('admin.users_page.email_placeholder')} type="email" className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
// //             <input name="phone" value={form.phone} onChange={handleChange} placeholder={t('admin.users_page.phone_placeholder', 'Phone Number')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
// //             <input name="password" value={form.password} onChange={handleChange} placeholder={t('admin.users_page.password_placeholder')} type="password" className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
// //             {/* Assign Store Profile: Only shown for main-store admins (not hostname store admins) */}
// //             {isMainStoreAdmin && (() => {
// //               // Profiles that already have at least one admin assigned
// //               const profilesWithAdmin = new Set(
// //                 users.filter(u => u.isAdmin && u.profile_id).map(u => u.profile_id)
// //               );
// //               const canBypass = form.is_master_admin || form.is_super_admin;
// //               return (
// //                 <select name="profile_id" value={form.profile_id} onChange={handleChange} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium bg-white">
// //                   <option value="">{t('admin.users_page.assign_profile_placeholder', 'Assign Store Profile...')}</option>
// //                   {profiles
// //                     .filter(p => p.hostname !== null || p.id === 'prof_01JK0000000000000000000001' || p.name === "Main Store Pack")
// //                     .map(p => {
// //                       const taken = profilesWithAdmin.has(p.id);
// //                       // For regular admin: disable profiles that already have an admin
// //                       return (
// //                         <option key={p.id} value={p.id} disabled={taken && !canBypass}>
// //                           {p.name}{taken ? ` (${t('admin.users_page.has_admin', 'has admin')})` : ''}
// //                         </option>
// //                       );
// //                     })
// //                   }
// //                 </select>
// //               );
// //             })()}
// //             <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm">
// //               <input type="checkbox" name="isAdmin" checked={form.isAdmin} onChange={handleChange} className="w-5 h-5 accent-brand-primary" id="isAdminCheck" />
// //               <label htmlFor="isAdminCheck" className="font-bold text-xs uppercase tracking-widest text-gray-600 cursor-pointer">{t('admin.users_page.make_admin')}</label>
// //             </div>
// //             {/* Master Admin & Super Admin options: only for users with master privileges */}
// //             {isAdminWithMasterPrivileges && (
// //               <>
// //                 <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm border border-amber-100">
// //                   <input type="checkbox" name="is_master_admin" checked={form.is_master_admin} onChange={handleChange} className="w-5 h-5 accent-amber-500" id="isMasterAdminCheck" />
// //                   <label htmlFor="isMasterAdminCheck" className="font-bold text-[10px] uppercase tracking-widest text-amber-700 cursor-pointer">
// //                     {t('admin.users_page.make_master_admin', 'Make Master Admin')}
// //                   </label>
// //                 </div>
// //                 <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm border border-indigo-100">
// //                   <input type="checkbox" name="is_super_admin" checked={form.is_super_admin} onChange={handleChange} className="w-5 h-5 accent-indigo-500" id="isSuperAdminCheck" />
// //                   <label htmlFor="isSuperAdminCheck" className="font-bold text-[10px] uppercase tracking-widest text-indigo-700 cursor-pointer">
// //                     {t('admin.users_page.make_super_admin', 'Make Super Admin')}
// //                   </label>
// //                 </div>
// //               </>
// //             )}
// //           </form>
// //           <button onClick={createUser} className="bg-brand-primary text-white px-8 py-4 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-brand-primary/20 hover:scale-105 active:scale-95 transition-all self-stretch md:self-auto h-[56px] flex items-center justify-center">
// //             {t('admin.users_page.create_btn')}
// //           </button>
// //         </div>
// //       </div>

// //       <div className="flex justify-between items-center mb-6 gap-4">
// //         <div className="relative flex-1 max-w-md">
// //           <i className="fas fa-search absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
// //           <input value={q} onChange={e => setQ(e.target.value)} placeholder={t('admin.common.search_placeholder', 'Search by username, email, or ID...')} className="w-full pl-12 pr-4 py-3 rounded-2xl border-none bg-gray-50 focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-medium" />
// //         </div>


// //       </div>

// //       {message && <div className="mb-6 p-4 bg-blue-50 text-blue-800 rounded-2xl font-medium border border-blue-100 flex items-center gap-3"><i className="fas fa-info-circle"></i>{message}</div>}

// //       {
// //         loading ? <div className="p-12 text-center text-gray-500 font-medium animate-pulse">{t('admin.common.loading')}</div> : (
// //           <div className="overflow-x-auto rounded-[30px] border border-gray-100 shadow-sm">
// //             <table className="w-full text-left">
// //               <thead className="bg-gray-50 border-b border-gray-100 text-gray-500">
// //                 <tr>
// //                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.common.id')}</th>
// //                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_username', 'Username')}</th>
// //                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_fullname', 'Full Name')}</th>
// //                   {hasPerm('users.email') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_email')}</th>}
// //                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_phone', 'Phone')}</th>
// //                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_admin')} / Role</th>
// //                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_permissions', 'Permissions')}</th>
// //                   {isAdminWithMasterPrivileges && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_store_profile', 'Store Profile')}</th>}
// //                   {hasPerm('users.created_at') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_created', 'Created')}</th>}
// //                   {hasPerm('users.updated_at') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_updated', 'Updated')}</th>}
// //                   <th className="p-5 font-black uppercase text-[10px] tracking-widest text-right">{t('admin.common.actions', 'Actions')}</th>
// //                 </tr>
// //               </thead>
// //               <tbody className="divide-y divide-gray-100">
// //                 {users.map(u => (
// //                   <tr key={u.id} className="hover:bg-gray-50/80 transition-colors group">
// //                     <td className="p-5 font-bold text-gray-600">#{u.id}</td>
// //                     <td className="p-5">
// //                       <div className="font-bold text-gray-900">{u.username}</div>
// //                       <div className="text-[10px] text-gray-400 font-medium">@{u.username}</div>
// //                     </td>
// //                     <td className="p-5 font-medium text-gray-900">{u.fullname || <span className="text-gray-300 italic">None</span>}</td>
// //                     {hasPerm('users.email') && <td className="p-5 font-medium text-gray-600">{u.email}</td>}
// //                     <td className="p-5 font-bold text-brand-primary text-xs whitespace-nowrap">{u.phone || <span className="text-gray-300">—</span>}</td>
// //                     <td className="p-5">
// //                       {/* ROLE DIFFERENTIATION:
// //                           - MASTER ADMIN (amber)  = has '*' AND (no profile / master profile) OR has '*' + 'master' marker on hostname profile
// //                           - SUPER ADMIN (indigo)  = has '*' + hostname profile (no 'master' marker)
// //                           - ADMIN (purple)         = isAdmin, no '*'
// //                           - USER (gray)            = not admin
// //                       */}
// //                       {u.isAdmin ? (
// //                         u.permissions && (u.permissions.includes('*') || u.permissions === '*') ? (
// //                           // Hostname profile without 'master' marker = Super Admin
// //                           u.profile_id && u.profile_id !== 'prof_01JK0000000000000000000001' && !u.permissions.includes('master') ? (
// //                             <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-indigo-200">
// //                               {t('admin.users_page.role_super_admin', 'SUPER ADMIN')}
// //                             </span>
// //                           ) : (
// //                             // No profile / master profile / or hostname with 'master' marker = Master Admin
// //                             <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-amber-200">
// //                               {t('admin.users_page.role_master_admin', 'MASTER ADMIN')}
// //                             </span>
// //                           )
// //                         ) : (
// //                           <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
// //                             {t('admin.users_page.role_admin', 'ADMIN')}
// //                           </span>
// //                         )
// //                       ) : (
// //                         <span className="bg-gray-100 text-gray-500 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
// //                           {t('admin.users_page.role_user', 'USER')}
// //                         </span>
// //                       )}
// //                     </td>
// //                     <td className="p-5">
// //                       {u.isAdmin &&
// //                         <div className="text-xs text-gray-500">
// //                           {u.permissions && (u.permissions.includes('*') || u.permissions === '*') ?
// //                             <span className="text-brand-primary font-bold">{t('admin.users_page.full_access', 'Full Access')}</span> :
// //                             (u.permissions?.length > 0 ? (Array.isArray(u.permissions) ? u.permissions.join(', ') : u.permissions) : t('admin.users_page.none', 'None'))
// //                           }
// //                         </div>
// //                       }
// //                     </td>
// //                     {isAdminWithMasterPrivileges && (
// //                       <td className="p-5">
// //                         {u.profile_id ? (
// //                           <div className="flex flex-col">
// //                             <span className="text-xs font-bold bg-indigo-50 text-indigo-700 px-2 py-1 rounded-lg w-fit">
// //                               {profiles.find(p => p.id === u.profile_id)?.name || `Profile #${u.profile_id}`}
// //                             </span>
// //                             <span className="text-[10px] text-gray-400 mt-1">{u.profile_id}</span>
// //                           </div>
// //                         ) : <span className="text-xs text-gray-400">—</span>}
// //                       </td>
// //                     )}
// //                     {hasPerm('users.created_at') && <td className="p-5 text-xs text-gray-500 whitespace-nowrap">{formatDate(u.created_at)}</td>}
// //                     {hasPerm('users.updated_at') && <td className="p-5 text-xs text-gray-500 whitespace-nowrap">{formatDate(u.updated_at)}</td>}
// //                     <td className="p-5 text-right">
// //                       <div className="flex gap-2 justify-end opacity-40 group-hover:opacity-100 transition-opacity">
// //                         {u.isAdmin && (
// //                           <button onClick={() => openPermissionModal(u)} className="w-8 h-8 rounded-full bg-blue-50 hover:bg-blue-500 hover:text-white text-blue-500 flex items-center justify-center transition-all" title={t('admin.users_page.edit_permissions', 'Edit Permissions')}>
// //                             <i className="fas fa-key text-xs"></i>
// //                           </button>
// //                         )}
// //                         <button onClick={() => toggleAdmin(u.id, !!u.isAdmin)} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-brand-primary hover:text-white text-gray-600 flex items-center justify-center transition-all" title={t('admin.users_page.toggle_role', 'Toggle Role')}>
// //                           <i className="fas fa-user-shield text-xs"></i>
// //                         </button>
// //                         <button onClick={() => deleteUser(u.id)} className="w-8 h-8 rounded-full bg-red-50 hover:bg-red-500 hover:text-white text-red-500 flex items-center justify-center transition-all" title={t('admin.common.delete', 'Delete')}>
// //                           <i className="fas fa-trash text-xs"></i>
// //                         </button>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 ))}
// //               </tbody>
// //             </table>
// //           </div>
// //         )
// //       }
// //       {
// //         total > 50 && (
// //           <div className="flex justify-center gap-4 items-center mt-8">
// //             <button onClick={() => fetchUsers(Math.max(1, page - 1))} disabled={page <= 1} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center disabled:opacity-50 transition-all font-bold">{isArabic ? "→" : "←"}</button>
// //             <div className="text-xs font-black uppercase tracking-widest text-gray-400">{t('admin.common.page', { current: page, total: Math.ceil(total / 50) })}</div>
// //             <button onClick={() => fetchUsers(page + 1)} disabled={page >= Math.ceil(total / 50)} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center disabled:opacity-50 transition-all font-bold">{isArabic ? "←" : "→"}</button>
// //           </div>
// //         )
// //       }

// //       {/* Permission Modal */}
// //       {editingUser && (
// //         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
// //           <div className="bg-white p-8 rounded-[30px] shadow-2xl max-w-lg w-full m-4">
// //             <h3 className="text-xl font-bold mb-4">Edit — {editingUser.username}</h3>

// //             <div className="grid grid-cols-2 gap-4 mb-6">
// //               <div>
// //                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_username', 'Username')}</label>
// //                 <input
// //                   value={editingUser.username || ''}
// //                   onChange={e => setEditingUser({ ...editingUser, username: e.target.value })}
// //                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
// //                 />
// //               </div>
// //               <div>
// //                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_fullname', 'Full Name')}</label>
// //                 <input
// //                   value={editingUser.fullname || ''}
// //                   onChange={e => setEditingUser({ ...editingUser, fullname: e.target.value })}
// //                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
// //                 />
// //               </div>
// //               <div className="col-span-2">
// //                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_phone', 'Phone Number')}</label>
// //                 <input
// //                   value={editingUser.phone || ''}
// //                   onChange={e => setEditingUser({ ...editingUser, phone: e.target.value })}
// //                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
// //                 />
// //               </div>
// //             </div>

// //             {/* Assign to Store Profile: Only for main-store admins, hidden for hostname store admins */}
// //             {isMainStoreAdmin && (
// //               <div className="mb-6 p-4 bg-indigo-50 rounded-2xl border border-indigo-100">
// //                 <label className="block text-xs font-black text-indigo-600 uppercase tracking-widest mb-2">🏪 {t('admin.users_page.assign_to_profile', 'Assign to Store Profile')}</label>
// //                 <select
// //                   value={editingUser.profile_id || ''}
// //                   onChange={e => setEditingUser({ ...editingUser, profile_id: e.target.value })}
// //                   className="w-full p-3 rounded-xl border border-indigo-200 bg-white font-medium text-sm focus:ring-2 focus:ring-indigo-300 outline-none"
// //                 >
// //                   <option value="">— {t('admin.users_page.no_profile_assigned', 'No profile assigned')} —</option>
// //                   {profiles
// //                     .filter(p => p.hostname !== null || p.id === 'prof_01JK0000000000000000000001' || p.name === "Main Store Pack" || p.id === editingUser.profile_id)
// //                     .map(p => (
// //                       <option key={p.id} value={p.id}>{p.name}{p.is_active ? ` ★ ${t('admin.users_page.primary', 'Primary')}` : ''}</option>
// //                     ))
// //                   }
// //                 </select>
// //                 <p className="text-[10px] text-indigo-400 mt-1 font-medium">{t('admin.users_page.profile_desc', 'This determines which isolated store this admin manages.')}</p>
// //               </div>
// //             )}

// //             <div className="flex flex-col gap-2 mb-6 max-h-[40vh] overflow-y-auto">
// //               {PERMISSION_OPTIONS.map(opt => {
// //                 // Security: Hide profile assignment permission from non-Main-Store Admins
// //                 if (opt.id === 'users.assign_profile' && !isMainStoreAdmin) return null;

// //                 return (
// //                   <React.Fragment key={opt.id}>
// //                     {/* Visual separator before the Full Access option */}
// //                     {opt.id === '*' && (
// //                       <div className="my-2 border-t border-gray-100 pt-2" />
// //                     )}
// //                     <label className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer border transition-colors ${opt.id === '*' ? 'hover:bg-amber-50 hover:border-amber-200 border-transparent' : 'hover:bg-gray-50 border-transparent hover:border-gray-100'}`}>
// //                       <input
// //                         type="checkbox"
// //                         checked={editingUser.permissions && editingUser.permissions.includes(opt.id)}
// //                         onChange={() => handlePermissionChange(opt.id)}
// //                         disabled={opt.id === '*' && editingUser.id === currentUserId}
// //                         className={`w-5 h-5 ${opt.id === '*' ? 'accent-amber-500' : 'accent-brand-primary'} disabled:opacity-50 disabled:cursor-not-allowed`}
// //                       />
// //                       <span className={`font-medium ${opt.id === '*' ? 'text-amber-700' : 'text-gray-700'}`}>
// //                         {opt.label}
// //                       </span>
// //                     </label>
// //                   </React.Fragment>
// //                 );
// //               })}
// //             </div>
// //             <div className="flex gap-3 justify-end">
// //               <button onClick={() => setEditingUser(null)} className="px-6 py-3 rounded-xl bg-gray-100 font-bold text-gray-600 hover:bg-gray-200">Cancel</button>
// //               <button onClick={savePermissions} className="px-6 py-3 rounded-xl bg-brand-primary font-bold text-white hover:bg-brand-primary/90">Save</button>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div >
// //   );
// // });

// // export default AdminUsers;
































































import React, { useEffect, useState, memo, useCallback } from "react";
import axios from "axios";
import { getToken } from "../../utils/auth";
import { useTranslation } from "react-i18next";
import CONFIG from "../../config";
import { maskEmail, maskUsername, maskFullName, maskPhone } from "../../utils/anonymizer";

const PERMISSION_OPTIONS = [
  { id: 'products', label: 'Products' },
  { id: 'categories', label: 'Categories' },
  { id: 'messages', label: 'Messages' },
  { id: 'reviews', label: 'Reviews' },
  { id: 'users', label: 'Users' },
  { id: 'analytics', label: 'Analytics' },
  { id: 'hero', label: 'Hero/Sliders' },
  { id: 'about', label: 'About Us' },
  { id: 'feedback', label: 'Feedback' },

  { id: 'users.email', label: 'Show User Email' },
  { id: 'users.created_at', label: 'Show User Created Date' },
  { id: 'users.updated_at', label: 'Show User Updated Date' },
  { id: 'categories.icon', label: 'Show Category Icon' },
  { id: 'categories.is_featured', label: 'Show Category Featured Status' },
  { id: 'logs.ip', label: 'Show Log IP Addresses' },
  { id: 'logs.details', label: 'Show Log Details' },
  { id: 'secrets.value', label: 'Show Secret Keys' },
  { id: 'users.assign_profile', label: 'Assign Users to Store Profiles' },

  { id: '*', label: 'Full Access (Super Admin)' },
];

const AdminUsers = memo(() => {
  const { t, i18n } = useTranslation();
  const [users, setUsers] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [q, setQ] = useState("");
  const [form, setForm] = useState({ username: "", fullname: "", email: "", phone: "", password: "", isAdmin: false, is_master_admin: false, permissions: [], profile_id: '' });
  const [message, setMessage] = useState("");

  const [editingUser, setEditingUser] = useState(null);

  const isArabic = i18n.language?.startsWith('ar');
  const apiBase = `${CONFIG.API_URL}/api/admin/users`;

  const [permissions, setPermissions] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  // Renamed from isMainApp to reflect that this check detects if the current logged-in user 
  // has Master/Super privileges (*) and is therefore allowed to create other Master Admins.
  const [isAdminWithMasterPrivileges, setIsAdminWithMasterPrivileges] = useState(false);
  // isMainStoreAdmin: true if the current user is on the main store (master profile or no profile).
  // Used to control visibility of profile assignment UI — hidden for hostname store admins.
  const [isMainStoreAdmin, setIsMainStoreAdmin] = useState(false);

  const [currentUserId, setCurrentUserId] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setIsAdmin(!!user.isAdmin);
    setCurrentUserId(user.id);
    setPermissions(user.permissions || []);
    // Determine if we are running on the main app (master) by asking server stats.
    (async () => {
      try {
        const token = getToken();
        const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/stats`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
        // isMaster = true only for global master admin (main store * admin)
        setIsAdminWithMasterPrivileges(!!res.data?.isMaster);
        // isMainStoreAdmin = true for any admin on the main store (master profile or no profile)
        setIsMainStoreAdmin(!!res.data?.isMainStoreAdmin);
      } catch (e) {
        setIsAdminWithMasterPrivileges(false);
        setIsMainStoreAdmin(false);
      }
    })();
  }, []);

  const hasPerm = (p) => {
    if (!isAdmin) return false;
    const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
    // If this is NOT the main store context (indicated by having a profile assigned to self),
    // and we are currently on a hostname-specific domain, restrict profile assignment features.
    const isHostnameContext = !isAdminWithMasterPrivileges && !!currentUser.profile_id;
    if (isHostnameContext && (p === 'users.assign_profile' || p === 'users.manage_profiles' || p === 'users.assign_profiles')) return false;

    // Super admins (those with '*' or Master Privileges) always have full control.
    if (isAdmin && (isAdminWithMasterPrivileges || !!currentUser.profile_id)) return true;

    if (permissions.includes('*') || permissions === '*') return true;
    return permissions.includes(p);
  };

  const getHeaders = useCallback(() => {
    const token = getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }, []);

  const fetchProfiles = useCallback(async () => {
    try {
      const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles`, { headers: getHeaders() });
      setProfiles(res.data || []);
    } catch (err) {
      console.error('Failed to load profiles', err);
    }
  }, [getHeaders]);

  const fetchUsers = useCallback(async (p = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(`${apiBase}?page=${p}&per=50&q=${encodeURIComponent(q)}`, { headers: getHeaders() });
      setUsers(res.data.data || []);
      setTotal(res.data.meta?.total || 0);
      setPage(p);
      setMessage(''); // Clear any previous error messages on success
    } catch (err) {
      console.error(err);
      if (err.response?.status === 403) {
        setMessage("Invalid Users Admin Secret. Access denied.");
      } else {
        setMessage(err.response?.data?.message || "Failed to load users");
      }
    } finally {
      setLoading(false);
    }
  }, [apiBase, q, getHeaders]);

  useEffect(() => { fetchUsers(); fetchProfiles(); }, [fetchUsers, fetchProfiles]);
  useEffect(() => { fetchUsers(1); }, [q, fetchUsers]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm(prev => {
      let next = { ...prev, [name]: type === 'checkbox' ? checked : value };

      // LOGIC: If 'Make Master Admin' is checked, we MUST also check 'Make Admin'.
      // A master admin cannot exist without being an administrator.
      if (name === 'is_master_admin' && checked) {
        next.isAdmin = true;
      }

      // If 'Make Admin' is unchecked while 'Master Admin' is still checked,
      // we uncheck 'Master Admin' too to maintain logical consistency.
      if (name === 'isAdmin' && !checked && prev.is_master_admin) {
        next.is_master_admin = false;
      }

      return next;
    });
  };

  const createUser = async (e) => {
    e.preventDefault();
    try {
      let perms = [...(form.permissions || [])];

      if (form.is_master_admin) {
        // Master Admins get the global wildcard permission.
        if (!perms.includes('*')) perms.push('*');
      } else if (form.isAdmin) {
        // BUG FIX: For standard admins (not master), ensure they don't get "None" permissions.
        // We assign a baseline set of standard management permissions by default.
        const defaultAdminPerms = ['products', 'categories', 'messages', 'reviews', 'hero', 'about', 'feedback'];
        defaultAdminPerms.forEach(p => {
          if (!perms.includes(p)) perms.push(p);
        });
      }

      const payload = { ...form, permissions: perms, isAdmin: form.isAdmin || form.is_master_admin };
      await axios.post(apiBase, payload, { headers: getHeaders() });
      setForm({ username: "", fullname: "", email: "", phone: "", password: "", isAdmin: false, is_master_admin: false, permissions: [], profile_id: '' });
      setMessage("User created successfully!");
      fetchUsers();
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || "Create failed");
    }
  };

  const toggleAdmin = async (id, currentIsAdmin) => {
    // Basic toggle. If making admin, permissions start empty.
    const userToUpdate = users.find(u => u.id === id);
    if (currentIsAdmin) {
      const adminCount = users.filter(u => u.isAdmin).length;
      if (adminCount <= 1 && userToUpdate.permissions?.includes('*')) {
        // Primitive check to prevent removing last super admin
        alert(t('admin.users_page.cannot_remove_last_admin', 'Cannot remove the last admin'));
        return;
      }
    }

    try {
      await axios.put(`${apiBase}/${id}/role`, { isAdmin: !currentIsAdmin, permissions: [] }, { headers: getHeaders() });
      fetchUsers();
    } catch (err) {
      console.error(err);
      setMessage("Update failed");
    }
  };

  const deleteUser = async (id) => {
    const userToDelete = users.find(u => u.id === id);
    if (userToDelete?.isAdmin) {
      const adminCount = users.filter(u => u.isAdmin).length;
      if (adminCount <= 1) {
        alert(t('admin.users_page.cannot_delete_last_admin', 'Cannot delete the last admin'));
        return;
      }
    }

    const confirmMessage = userToDelete?.isAdmin ? "Delete this admin?" : "Delete this user?";
    if (!window.confirm(confirmMessage)) return;
    try {
      await axios.delete(`${apiBase}/${id}`, { headers: getHeaders() });
      fetchUsers();
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || "Delete failed");
    }
  };

  // -- Permission Modal Logic --
  const openPermissionModal = (user) => {
    let perms = [];
    if (Array.isArray(user.permissions)) perms = user.permissions;
    else if (typeof user.permissions === 'string') {
      if (user.permissions === '*') perms = ['*'];
      else try { perms = JSON.parse(user.permissions); } catch (e) { }
    }
    setEditingUser({ ...user, fullname: user.fullname || '', phone: user.phone || '', permissions: perms, profile_id: user.profile_id || '' });
  };

  const handlePermissionChange = (permId) => {
    if (!editingUser) return;

    // Prevent self-demotion from Super Admin
    if (permId === '*' && editingUser.id === currentUserId && editingUser.permissions.includes('*')) {
      alert("You cannot remove your own 'Full Access' permission to prevent accidental lockout.");
      return;
    }

    let newPerms = [...(editingUser.permissions || [])];

    if (permId === '*') {
      // If selecting Full Access, clear others? Or just toggle?
      // Let's say if we toggle *, we add/remove it.
      if (newPerms.includes('*')) newPerms = newPerms.filter(p => p !== '*');
      else newPerms = ['*']; // Exclusive? Or just include? Let's make it exclusive for cleanliness
    } else {
      // If * exists, remove it if we selecting specific? 
      // Implementation choice: If * is present, usually implies everything. 
      // If we uncheck *, we go back to nothing.
      if (newPerms.includes('*')) newPerms = [];

      if (newPerms.includes(permId)) {
        newPerms = newPerms.filter(p => p !== permId);
      } else {
        newPerms.push(permId);
      }
    }
    setEditingUser({ ...editingUser, permissions: newPerms });
  };

  const savePermissions = async () => {
    if (!editingUser) return;
    try {
      // CONSOLIDATED UPDATE: We send isAdmin, permissions, and profile_id in a single request.
      // This is more efficient and avoids potential race conditions or partial saves.
      await axios.put(`${apiBase}/${editingUser.id}`, {
        username: editingUser.username,
        fullname: editingUser.fullname,
        phone: editingUser.phone,
        isAdmin: true, // If we are editing permissions, they are implicitly an admin.
        permissions: editingUser.permissions,
        profile_id: editingUser.profile_id
      }, { headers: getHeaders() });

      setEditingUser(null);
      fetchUsers();
      setMessage("Permissions & profile updated successfully!");
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || "Failed to update permissions");
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString(i18n.language, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  };


  return (
    <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
      <div className="flex items-center justify-between mb-12">
        <h2 className="text-4xl font-black text-gray-900 tracking-tight">{t('admin.users_page.title')}</h2>
        <div className="flex items-center gap-4">
          <button
            onClick={() => window.history.back()}
            className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all"
          >
            <span className={`inline-block transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>←</span>
            {t('admin.common.back', 'Back')}
          </button>
        </div>
      </div>

      <div className="bg-brand-primary/5 p-8 rounded-[30px] border border-brand-primary/10 mb-8">
        <h3 className="font-bold text-gray-900 mb-6 flex items-center gap-2">
          <span className="w-8 h-8 rounded-full bg-brand-primary text-white flex items-center justify-center text-sm"><i className="fas fa-plus"></i></span>
          {t('admin.users_page.create_new_user', 'Create New User')}
        </h3>
        <div className="flex flex-col md:flex-row items-end gap-4">
          <form onSubmit={createUser} className="grid grid-cols-1 md:grid-cols-5 gap-4 flex-1 w-full">
            <input name="username" value={form.username} onChange={handleChange} placeholder={t('admin.users_page.username_placeholder')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
            <input name="fullname" value={form.fullname} onChange={handleChange} placeholder={t('admin.users_page.fullname_placeholder', 'Full Name')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
            <input name="email" value={form.email} onChange={handleChange} placeholder={t('admin.users_page.email_placeholder')} type="email" className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
            <input name="phone" value={form.phone} onChange={handleChange} placeholder={t('admin.users_page.phone_placeholder', 'Phone Number')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
            <input name="password" value={form.password} onChange={handleChange} placeholder={t('admin.users_page.password_placeholder')} type="password" className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
            {/* Assign Store Profile: Only shown for main-store admins (not hostname store admins) */}
            {isMainStoreAdmin && (
              <select name="profile_id" value={form.profile_id} onChange={handleChange} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium bg-white">
                <option value="">{t('admin.users_page.assign_profile_placeholder', 'Assign Store Profile...')}</option>
                {profiles
                  .filter(p => p.hostname !== null || p.id === 'prof_01JK0000000000000000000001' || p.name === "Main Store Pack")
                  .map(p => <option key={p.id} value={p.id}>{p.name}</option>)
                }
              </select>
            )}
            <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm">
              <input type="checkbox" name="isAdmin" checked={form.isAdmin} onChange={handleChange} className="w-5 h-5 accent-brand-primary" id="isAdminCheck" />
              <label htmlFor="isAdminCheck" className="font-bold text-xs uppercase tracking-widest text-gray-600 cursor-pointer">{t('admin.users_page.make_admin')}</label>
            </div>
            {/* Feature Visibility: Only show the "Make Master Admin" option if the CURRENT user has Master privileges. */}
            {isAdminWithMasterPrivileges && (
              <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm border border-amber-100">
                <input type="checkbox" name="is_master_admin" checked={form.is_master_admin} onChange={handleChange} className="w-5 h-5 accent-amber-500" id="isMasterAdminCheck" />
                <label htmlFor="isMasterAdminCheck" className="font-bold text-[10px] uppercase tracking-widest text-amber-700 cursor-pointer">{t('admin.users_page.make_master_admin', 'Make Master Admin')}</label>
              </div>
            )}
          </form>
          <button onClick={createUser} className="bg-brand-primary text-white px-8 py-4 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-brand-primary/20 hover:scale-105 active:scale-95 transition-all self-stretch md:self-auto h-[56px] flex items-center justify-center">
            {t('admin.users_page.create_btn')}
          </button>
        </div>
      </div>

      <div className="flex justify-between items-center mb-6 gap-4">
        <div className="relative flex-1 max-w-md">
          <i className="fas fa-search absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
          <input value={q} onChange={e => setQ(e.target.value)} placeholder={t('admin.common.search_placeholder', 'Search by username, email, or ID...')} className="w-full pl-12 pr-4 py-3 rounded-2xl border-none bg-gray-50 focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-medium" />
        </div>


      </div>

      {message && <div className="mb-6 p-4 bg-blue-50 text-blue-800 rounded-2xl font-medium border border-blue-100 flex items-center gap-3"><i className="fas fa-info-circle"></i>{message}</div>}

      {
        loading ? <div className="p-12 text-center text-gray-500 font-medium animate-pulse">{t('admin.common.loading')}</div> : (
          <div className="overflow-x-auto rounded-[30px] border border-gray-100 shadow-sm">
            <table className="w-full text-left">
              <thead className="bg-gray-50 border-b border-gray-100 text-gray-500">
                <tr>
                  <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.common.id')}</th>
                  <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_username', 'Username')}</th>
                  <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_fullname', 'Full Name')}</th>
                  {hasPerm('users.email') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_email')}</th>}
                  <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_phone', 'Phone')}</th>
                  <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_admin')} / Role</th>
                  <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_permissions', 'Permissions')}</th>
                  {isAdminWithMasterPrivileges && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_store_profile', 'Store Profile')}</th>}
                  {hasPerm('users.created_at') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_created', 'Created')}</th>}
                  {hasPerm('users.updated_at') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_updated', 'Updated')}</th>}
                  <th className="p-5 font-black uppercase text-[10px] tracking-widest text-right">{t('admin.common.actions', 'Actions')}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {users.map(u => (
                  <tr key={u.id} className="hover:bg-gray-50/80 transition-colors group">
                    <td className="p-5 font-bold text-gray-600">#{u.id}</td>
                    <td className="p-5">
                      <div className="font-bold text-gray-900">{u && maskUsername(u?.username)}</div>
                      <div className="text-[10px] text-gray-400 font-medium">@{u && maskUsername(u?.username)}</div>
                    </td>
                    <td className="p-5 font-medium text-gray-900">{u ? maskFullName(u?.fullname) : <span className="text-gray-300 italic">None</span>}</td>
                    {hasPerm('users.email') && <td className="p-5 font-medium text-gray-600">{u && maskEmail(u?.email)}</td>}
                    <td className="p-5 font-bold text-brand-primary text-xs whitespace-nowrap">{u ? maskPhone(u?.phone) : <span className="text-gray-300">—</span>}</td>
                    <td className="p-5">
                      {/* ROLE DIFFERENTIATION:
                          - MASTER ADMIN (amber)  = has '*' AND is on main store (no profile or master profile)
                          - SUPER ADMIN (indigo)  = has '*' AND is on a hostname-specific store profile
                          - ADMIN (purple)         = isAdmin, no '*'
                          - USER (gray)            = not admin
                      */}
                      {u.isAdmin ? (
                        u.permissions && (u.permissions.includes('*') || u.permissions === '*') ? (
                          u.profile_id && u.profile_id !== 'prof_01JK0000000000000000000001' ? (
                            <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-indigo-200">
                              {t('admin.users_page.role_super_admin', 'SUPER ADMIN')}
                            </span>
                          ) : (
                            <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-amber-200">
                              {t('admin.users_page.role_master_admin', 'MASTER ADMIN')}
                            </span>
                          )
                        ) : (
                          <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
                            {t('admin.users_page.role_admin', 'ADMIN')}
                          </span>
                        )
                      ) : (
                        <span className="bg-gray-100 text-gray-500 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
                          {t('admin.users_page.role_user', 'USER')}
                        </span>
                      )}
                    </td>
                    <td className="p-5">
                      {u.isAdmin &&
                        <div className="text-xs text-gray-500">
                          {u.permissions && (u.permissions.includes('*') || u.permissions === '*') ?
                            <span className="text-brand-primary font-bold">{t('admin.users_page.full_access', 'Full Access')}</span> :
                            (u.permissions?.length > 0 ? (Array.isArray(u.permissions) ? u.permissions.join(', ') : u.permissions) : t('admin.users_page.none', 'None'))
                          }
                        </div>
                      }
                    </td>
                    {isAdminWithMasterPrivileges && (
                      <td className="p-5">
                        {u.profile_id ? (
                          <div className="flex flex-col">
                            <span className="text-xs font-bold bg-indigo-50 text-indigo-700 px-2 py-1 rounded-lg w-fit">
                              {profiles.find(p => p.id === u.profile_id)?.name || `Profile #${u.profile_id}`}
                            </span>
                            <span className="text-[10px] text-gray-400 mt-1">{u.profile_id}</span>
                          </div>
                        ) : <span className="text-xs text-gray-400">—</span>}
                      </td>
                    )}
                    {hasPerm('users.created_at') && <td className="p-5 text-xs text-gray-500 whitespace-nowrap">{formatDate(u.created_at)}</td>}
                    {hasPerm('users.updated_at') && <td className="p-5 text-xs text-gray-500 whitespace-nowrap">{formatDate(u.updated_at)}</td>}
                    <td className="p-5 text-right">
                      <div className="flex gap-2 justify-end opacity-40 group-hover:opacity-100 transition-opacity">
                        {u.isAdmin && (
                          <button onClick={() => openPermissionModal(u)} className="w-8 h-8 rounded-full bg-blue-50 hover:bg-blue-500 hover:text-white text-blue-500 flex items-center justify-center transition-all" title={t('admin.users_page.edit_permissions', 'Edit Permissions')}>
                            <i className="fas fa-key text-xs"></i>
                          </button>
                        )}
                        <button onClick={() => toggleAdmin(u.id, !!u.isAdmin)} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-brand-primary hover:text-white text-gray-600 flex items-center justify-center transition-all" title={t('admin.users_page.toggle_role', 'Toggle Role')}>
                          <i className="fas fa-user-shield text-xs"></i>
                        </button>
                        < button onClick={() => deleteUser(u.id)} className="w-8 h-8 rounded-full bg-red-50 hover:bg-red-500 hover:text-white text-red-500 flex items-center justify-center transition-all" title={t('admin.common.delete', 'Delete')}>
                          <i className="fas fa-trash text-xs"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      }
      {
        total > 50 && (
          <div className="flex justify-center gap-4 items-center mt-8">
            <button onClick={() => fetchUsers(Math.max(1, page - 1))} disabled={page <= 1} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center disabled:opacity-50 transition-all font-bold">{isArabic ? "→" : "←"}</button>
            <div className="text-xs font-black uppercase tracking-widest text-gray-400">{t('admin.common.page', { current: page, total: Math.ceil(total / 50) })}</div>
            <button onClick={() => fetchUsers(page + 1)} disabled={page >= Math.ceil(total / 50)} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center disabled:opacity-50 transition-all font-bold">{isArabic ? "←" : "→"}</button>
          </div>
        )
      }

      {/* Permission Modal */}
      {
        editingUser && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
            <div className="bg-white p-8 rounded-[30px] shadow-2xl max-w-lg w-full m-4">
              <h3 className="text-xl font-bold mb-4">Edit — {editingUser.username}</h3>

              <div className="grid grid-cols-2 gap-4 mb-6">
                <div>
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_username', 'Username')}</label>
                  <input
                    value={editingUser.username || ''}
                    onChange={e => setEditingUser({ ...editingUser, username: e.target.value })}
                    className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
                  />
                </div>
                <div>
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_fullname', 'Full Name')}</label>
                  <input
                    value={editingUser.fullname || ''}
                    onChange={e => setEditingUser({ ...editingUser, fullname: e.target.value })}
                    className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
                  />
                </div>
                <div className="col-span-2">
                  <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_phone', 'Phone Number')}</label>
                  <input
                    value={editingUser.phone || ''}
                    onChange={e => setEditingUser({ ...editingUser, phone: e.target.value })}
                    className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
                  />
                </div>
              </div>

              {/* Assign to Store Profile: Only for main-store admins, hidden for hostname store admins */}
              {isMainStoreAdmin && (
                <div className="mb-6 p-4 bg-indigo-50 rounded-2xl border border-indigo-100">
                  <label className="block text-xs font-black text-indigo-600 uppercase tracking-widest mb-2">🏪 {t('admin.users_page.assign_to_profile', 'Assign to Store Profile')}</label>
                  <select
                    value={editingUser.profile_id || ''}
                    onChange={e => setEditingUser({ ...editingUser, profile_id: e.target.value })}
                    className="w-full p-3 rounded-xl border border-indigo-200 bg-white font-medium text-sm focus:ring-2 focus:ring-indigo-300 outline-none"
                  >
                    <option value="">— {t('admin.users_page.no_profile_assigned', 'No profile assigned')} —</option>
                    {profiles
                      .filter(p => p.hostname !== null || p.id === 'prof_01JK0000000000000000000001' || p.name === "Main Store Pack" || p.id === editingUser.profile_id)
                      .map(p => (
                        <option key={p.id} value={p.id}>{p.name}{p.is_active ? ` ★ ${t('admin.users_page.primary', 'Primary')}` : ''}</option>
                      ))
                    }
                  </select>
                  <p className="text-[10px] text-indigo-400 mt-1 font-medium">{t('admin.users_page.profile_desc', 'This determines which isolated store this admin manages.')}</p>
                </div>
              )}

              {/* Data Subject Rights processing restrictions UI */}
              {isAdminWithMasterPrivileges && (editingUser.isProcessingRestricted || editingUser.objectToProcessing) && (
                <div className="mb-6 p-4 bg-red-50 rounded-2xl border border-red-100">
                  <label className="block text-xs font-black text-red-600 uppercase tracking-widest mb-2">🛑 {t('admin.users_page.processing_restrictions', 'Processing Restrictions')}</label>
                  <div className="flex flex-col gap-2">
                    {editingUser.isProcessingRestricted && <span className="text-red-700 text-sm font-bold">• Processing is currently restricted for this user</span>}
                    {editingUser.objectToProcessing && <span className="text-red-700 text-sm font-bold">• User Objected to Processing (Since: {new Date(editingUser.objectionTimestamp).toLocaleString()})</span>}
                  </div>
                  <button onClick={async () => {
                    try {
                      const token = localStorage.getItem('token');
                      await axios.put(`${CONFIG.API_URL}/api/admin/data-subject/users/${editingUser.id}/lift-restriction`, {}, { headers: { Authorization: `Bearer ${token}` } });
                      alert("Restrictions lifted!");
                      setEditingUser({ ...editingUser, isProcessingRestricted: false, objectToProcessing: false, objectionTimestamp: null });
                      fetchUsers();
                    } catch (e) {
                      alert("Failed to lift restriction. Refresh the page to reload permissions.");
                    }
                  }} className="mt-4 bg-red-600 text-white px-4 py-2 rounded-xl font-bold hover:bg-red-700 text-xs tracking-widest uppercase shadow shadow-red-200">
                    {t('admin.users_page.lift_restrictions', 'Lift All Restrictions')}
                  </button>
                </div>
              )}


              <div className="flex flex-col gap-2 mb-6 max-h-[40vh] overflow-y-auto">
                {PERMISSION_OPTIONS.map(opt => {
                  // Security: Hide profile assignment permission from non-Main-Store Admins
                  if (opt.id === 'users.assign_profile' && !isMainStoreAdmin) return null;

                  return (
                    <React.Fragment key={opt.id}>
                      {/* Visual separator before the Full Access option */}
                      {opt.id === '*' && (
                        <div className="my-2 border-t border-gray-100 pt-2" />
                      )}
                      <label className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer border transition-colors ${opt.id === '*' ? 'hover:bg-amber-50 hover:border-amber-200 border-transparent' : 'hover:bg-gray-50 border-transparent hover:border-gray-100'}`}>
                        <input
                          type="checkbox"
                          checked={editingUser.permissions && editingUser.permissions.includes(opt.id)}
                          onChange={() => handlePermissionChange(opt.id)}
                          disabled={opt.id === '*' && editingUser.id === currentUserId}
                          className={`w-5 h-5 ${opt.id === '*' ? 'accent-amber-500' : 'accent-brand-primary'} disabled:opacity-50 disabled:cursor-not-allowed`}
                        />
                        <span className={`font-medium ${opt.id === '*' ? 'text-amber-700' : 'text-gray-700'}`}>
                          {opt.label}
                        </span>
                      </label>
                    </React.Fragment>
                  );
                })}
              </div>
              <div className="flex gap-3 justify-end">
                <button onClick={() => setEditingUser(null)} className="px-6 py-3 rounded-xl bg-gray-100 font-bold text-gray-600 hover:bg-gray-200">Cancel</button>
                <button onClick={savePermissions} className="px-6 py-3 rounded-xl bg-brand-primary font-bold text-white hover:bg-brand-primary/90">Save</button>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
});

export default AdminUsers;












// import React, { useEffect, useState, memo, useCallback } from "react";
// import axios from "axios";
// import { getToken } from "../../utils/auth";
// import { useTranslation } from "react-i18next";
// import CONFIG from "../../config";

// const PERMISSION_OPTIONS = [
//   { id: 'products', label: 'Products' },
//   { id: 'categories', label: 'Categories' },
//   { id: 'messages', label: 'Messages' },
//   { id: 'reviews', label: 'Reviews' },
//   { id: 'users', label: 'Users' },
//   { id: 'analytics', label: 'Analytics' },
//   { id: 'hero', label: 'Hero/Sliders' },
//   { id: 'about', label: 'About Us' },
//   { id: 'feedback', label: 'Feedback' },

//   { id: 'users.email', label: 'Show User Email' },
//   { id: 'users.created_at', label: 'Show User Created Date' },
//   { id: 'users.updated_at', label: 'Show User Updated Date' },
//   { id: 'categories.icon', label: 'Show Category Icon' },
//   { id: 'categories.is_featured', label: 'Show Category Featured Status' },
//   { id: 'logs.ip', label: 'Show Log IP Addresses' },
//   { id: 'logs.details', label: 'Show Log Details' },
//   { id: 'secrets.value', label: 'Show Secret Keys' },
//   { id: 'users.assign_profile', label: 'Assign Users to Store Profiles' },

//   { id: '*', label: 'Full Access (Super Admin)' },
// ];

// const AdminUsers = memo(() => {
//   const { t, i18n } = useTranslation();
//   const [users, setUsers] = useState([]);
//   const [profiles, setProfiles] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [q, setQ] = useState("");
//   const [form, setForm] = useState({ username: "", fullname: "", email: "", phone: "", password: "", isAdmin: false, is_master_admin: false, is_super_admin: false, permissions: [], profile_id: '' });
//   const [message, setMessage] = useState("");

//   const [editingUser, setEditingUser] = useState(null);

//   const isArabic = i18n.language?.startsWith('ar');
//   const apiBase = `${CONFIG.API_URL}/api/admin/users`;

//   const [permissions, setPermissions] = useState([]);
//   const [isAdmin, setIsAdmin] = useState(false);
//   // Renamed from isMainApp to reflect that this check detects if the current logged-in user 
//   // has Master/Super privileges (*) and is therefore allowed to create other Master Admins.
//   const [isAdminWithMasterPrivileges, setIsAdminWithMasterPrivileges] = useState(false);
//   // isMainStoreAdmin: true if the current user is on the main store (master profile or no profile).
//   // Used to control visibility of profile assignment UI — hidden for hostname store admins.
//   const [isMainStoreAdmin, setIsMainStoreAdmin] = useState(false);

//   const [currentUserId, setCurrentUserId] = useState(null);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user") || "{}");
//     setIsAdmin(!!user.isAdmin);
//     setCurrentUserId(user.id);
//     setPermissions(user.permissions || []);
//     // Determine if we are running on the main app (master) by asking server stats.
//     (async () => {
//       try {
//         const token = getToken();
//         const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/stats`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
//         // isMaster = true only for global master admin (main store * admin)
//         setIsAdminWithMasterPrivileges(!!res.data?.isMaster);
//         // isMainStoreAdmin = true for any admin on the main store (master profile or no profile)
//         setIsMainStoreAdmin(!!res.data?.isMainStoreAdmin);
//       } catch (e) {
//         setIsAdminWithMasterPrivileges(false);
//         setIsMainStoreAdmin(false);
//       }
//     })();
//   }, []);

//   const hasPerm = (p) => {
//     if (!isAdmin) return false;
//     const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
//     // If this is NOT the main store context (indicated by having a profile assigned to self),
//     // and we are currently on a hostname-specific domain, restrict profile assignment features.
//     const isHostnameContext = !isAdminWithMasterPrivileges && !!currentUser.profile_id;
//     if (isHostnameContext && (p === 'users.assign_profile' || p === 'users.manage_profiles' || p === 'users.assign_profiles')) return false;

//     // Super admins (those with '*' or Master Privileges) always have full control.
//     if (isAdmin && (isAdminWithMasterPrivileges || !!currentUser.profile_id)) return true;

//     if (permissions.includes('*') || permissions === '*') return true;
//     return permissions.includes(p);
//   };

//   const getHeaders = useCallback(() => {
//     const token = getToken();
//     return token ? { Authorization: `Bearer ${token}` } : {};
//   }, []);

//   const fetchProfiles = useCallback(async () => {
//     try {
//       const res = await axios.get(`${CONFIG.API_URL}/api/admin/configs/profiles`, { headers: getHeaders() });
//       setProfiles(res.data || []);
//     } catch (err) {
//       console.error('Failed to load profiles', err);
//     }
//   }, [getHeaders]);

//   const fetchUsers = useCallback(async (p = 1) => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${apiBase}?page=${p}&per=50&q=${encodeURIComponent(q)}`, { headers: getHeaders() });
//       setUsers(res.data.data || []);
//       setTotal(res.data.meta?.total || 0);
//       setPage(p);
//     } catch (err) {
//       console.error(err);
//       if (err.response?.status === 403) {
//         setMessage("Invalid Users Admin Secret. Access denied.");
//       } else {
//         setMessage(err.response?.data?.message || "Failed to load users");
//       }
//     } finally {
//       setLoading(false);
//     }
//   }, [apiBase, q, getHeaders]);

//   useEffect(() => { fetchUsers(); fetchProfiles(); }, [fetchUsers, fetchProfiles]);
//   useEffect(() => { fetchUsers(1); }, [q, fetchUsers]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setForm(prev => {
//       let next = { ...prev, [name]: type === 'checkbox' ? checked : value };

//       // Master Admin requires isAdmin
//       if (name === 'is_master_admin' && checked) {
//         next.isAdmin = true;
//         next.is_super_admin = false; // mutually exclusive
//       }

//       // Super Admin requires isAdmin
//       if (name === 'is_super_admin' && checked) {
//         next.isAdmin = true;
//         next.is_master_admin = false; // mutually exclusive
//       }

//       // If 'Make Admin' is unchecked, uncheck both elevated roles
//       if (name === 'isAdmin' && !checked) {
//         next.is_master_admin = false;
//         next.is_super_admin = false;
//       }

//       return next;
//     });
//   };

//   const createUser = async (e) => {
//     e.preventDefault();
//     try {
//       let perms = [...(form.permissions || [])];
//       const isHostnameProfile = form.profile_id && form.profile_id !== 'prof_01JK0000000000000000000001';

//       if (form.is_master_admin) {
//         if (!perms.includes('*')) perms.push('*');
//         // For hostname profiles: add 'master' marker so the badge shows MASTER ADMIN (amber)
//         // For no-profile / main profile: 'master' marker is not needed (profile_id already identifies them)
//         if (isHostnameProfile && !perms.includes('master')) perms.push('master');
//       } else if (form.is_super_admin) {
//         // Super Admin: wildcard only, no 'master' marker → SUPER ADMIN (indigo) badge for hostname profiles
//         if (!perms.includes('*')) perms.push('*');
//       } else if (form.isAdmin) {
//         // Standard admin: baseline permissions
//         const defaultAdminPerms = ['products', 'categories', 'messages', 'reviews', 'hero', 'about', 'feedback'];
//         defaultAdminPerms.forEach(p => {
//           if (!perms.includes(p)) perms.push(p);
//         });
//       }

//       const payload = { ...form, permissions: perms, isAdmin: form.isAdmin || form.is_master_admin || form.is_super_admin };
//       await axios.post(apiBase, payload, { headers: getHeaders() });
//       setForm({ username: "", fullname: "", email: "", phone: "", password: "", isAdmin: false, is_master_admin: false, is_super_admin: false, permissions: [], profile_id: '' });
//       setMessage("User created successfully!");
//       fetchUsers();
//     } catch (err) {
//       console.error(err);
//       setMessage(err.response?.data?.message || "Create failed");
//     }
//   };

//   const toggleAdmin = async (id, currentIsAdmin) => {
//     // Basic toggle. If making admin, permissions start empty.
//     const userToUpdate = users.find(u => u.id === id);
//     if (currentIsAdmin) {
//       const adminCount = users.filter(u => u.isAdmin).length;
//       if (adminCount <= 1 && userToUpdate.permissions?.includes('*')) {
//         // Primitive check to prevent removing last super admin
//         alert(t('admin.users_page.cannot_remove_last_admin', 'Cannot remove the last admin'));
//         return;
//       }
//     }

//     try {
//       await axios.put(`${apiBase}/${id}/role`, { isAdmin: !currentIsAdmin, permissions: [] }, { headers: getHeaders() });
//       fetchUsers();
//     } catch (err) {
//       console.error(err);
//       setMessage("Update failed");
//     }
//   };

//   const deleteUser = async (id) => {
//     const userToDelete = users.find(u => u.id === id);
//     if (userToDelete?.isAdmin) {
//       const adminCount = users.filter(u => u.isAdmin).length;
//       if (adminCount <= 1) {
//         alert(t('admin.users_page.cannot_delete_last_admin', 'Cannot delete the last admin'));
//         return;
//       }
//     }

//     const confirmMessage = userToDelete?.isAdmin ? "Delete this admin?" : "Delete this user?";
//     if (!window.confirm(confirmMessage)) return;
//     try {
//       await axios.delete(`${apiBase}/${id}`, { headers: getHeaders() });
//       fetchUsers();
//     } catch (err) {
//       console.error(err);
//       setMessage(err.response?.data?.message || "Delete failed");
//     }
//   };

//   // -- Permission Modal Logic --
//   const openPermissionModal = (user) => {
//     let perms = [];
//     if (Array.isArray(user.permissions)) perms = user.permissions;
//     else if (typeof user.permissions === 'string') {
//       try { perms = JSON.parse(user.permissions); } catch (e) { }
//     }
//     setEditingUser({ ...user, fullname: user.fullname || '', phone: user.phone || '', permissions: perms, profile_id: user.profile_id || '' });
//   };

//   const handlePermissionChange = (permId) => {
//     if (!editingUser) return;

//     // Prevent self-demotion from Super Admin
//     if (permId === '*' && editingUser.id === currentUserId && editingUser.permissions.includes('*')) {
//       alert("You cannot remove your own 'Full Access' permission to prevent accidental lockout.");
//       return;
//     }

//     let newPerms = [...(editingUser.permissions || [])];

//     if (permId === '*') {
//       // If selecting Full Access, clear others? Or just toggle?
//       // Let's say if we toggle *, we add/remove it.
//       if (newPerms.includes('*')) newPerms = newPerms.filter(p => p !== '*');
//       else newPerms = ['*']; // Exclusive? Or just include? Let's make it exclusive for cleanliness
//     } else {
//       // If * exists, remove it if we selecting specific? 
//       // Implementation choice: If * is present, usually implies everything. 
//       // If we uncheck *, we go back to nothing.
//       if (newPerms.includes('*')) newPerms = [];

//       if (newPerms.includes(permId)) {
//         newPerms = newPerms.filter(p => p !== permId);
//       } else {
//         newPerms.push(permId);
//       }
//     }
//     setEditingUser({ ...editingUser, permissions: newPerms });
//   };

//   const savePermissions = async () => {
//     if (!editingUser) return;
//     try {
//       // CONSOLIDATED UPDATE: We send isAdmin, permissions, and profile_id in a single request.
//       // This is more efficient and avoids potential race conditions or partial saves.
//       await axios.put(`${apiBase}/${editingUser.id}`, {
//         username: editingUser.username,
//         fullname: editingUser.fullname,
//         phone: editingUser.phone,
//         isAdmin: true, // If we are editing permissions, they are implicitly an admin.
//         permissions: editingUser.permissions,
//         profile_id: editingUser.profile_id
//       }, { headers: getHeaders() });

//       setEditingUser(null);
//       fetchUsers();
//       setMessage("Permissions & profile updated successfully!");
//     } catch (err) {
//       console.error(err);
//       setMessage(err.response?.data?.message || "Failed to update permissions");
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     return new Date(dateString).toLocaleDateString(i18n.language, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
//   };


//   return (
//     <div className="max-w-7xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
//       <div className="flex items-center justify-between mb-12">
//         <h2 className="text-4xl font-black text-gray-900 tracking-tight">{t('admin.users_page.title')}</h2>
//         <div className="flex items-center gap-4">
//           <button
//             onClick={() => window.history.back()}
//             className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all"
//           >
//             <span className={`inline-block transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>←</span>
//             {t('admin.common.back', 'Back')}
//           </button>
//         </div>
//       </div>

//       <div className="bg-brand-primary/5 p-8 rounded-[30px] border border-brand-primary/10 mb-8">
//         <h3 className="font-bold text-gray-900 mb-6 flex items-center gap-2">
//           <span className="w-8 h-8 rounded-full bg-brand-primary text-white flex items-center justify-center text-sm"><i className="fas fa-plus"></i></span>
//           {t('admin.users_page.create_new_user', 'Create New User')}
//         </h3>
//         <div className="flex flex-col md:flex-row items-end gap-4">
//           <form onSubmit={createUser} className="grid grid-cols-1 md:grid-cols-5 gap-4 flex-1 w-full">
//             <input name="username" value={form.username} onChange={handleChange} placeholder={t('admin.users_page.username_placeholder')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             <input name="fullname" value={form.fullname} onChange={handleChange} placeholder={t('admin.users_page.fullname_placeholder', 'Full Name')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             <input name="email" value={form.email} onChange={handleChange} placeholder={t('admin.users_page.email_placeholder')} type="email" className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             <input name="phone" value={form.phone} onChange={handleChange} placeholder={t('admin.users_page.phone_placeholder', 'Phone Number')} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             <input name="password" value={form.password} onChange={handleChange} placeholder={t('admin.users_page.password_placeholder')} type="password" className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium" />
//             {/* Assign Store Profile: Only shown for main-store admins (not hostname store admins) */}
//             {isMainStoreAdmin && (() => {
//               // Profiles that already have at least one admin assigned
//               const profilesWithAdmin = new Set(
//                 users.filter(u => u.isAdmin && u.profile_id).map(u => u.profile_id)
//               );
//               const canBypass = form.is_master_admin || form.is_super_admin;
//               return (
//                 <select name="profile_id" value={form.profile_id} onChange={handleChange} className="p-4 rounded-xl border-none shadow-sm focus:ring-2 focus:ring-brand-primary/20 font-medium bg-white">
//                   <option value="">{t('admin.users_page.assign_profile_placeholder', 'Assign Store Profile...')}</option>
//                   {profiles
//                     .filter(p => p.hostname !== null || p.id === 'prof_01JK0000000000000000000001' || p.name === "Main Store Pack")
//                     .map(p => {
//                       const taken = profilesWithAdmin.has(p.id);
//                       // For regular admin: disable profiles that already have an admin
//                       return (
//                         <option key={p.id} value={p.id} disabled={taken && !canBypass}>
//                           {p.name}{taken ? ` (${t('admin.users_page.has_admin', 'has admin')})` : ''}
//                         </option>
//                       );
//                     })
//                   }
//                 </select>
//               );
//             })()}
//             <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm">
//               <input type="checkbox" name="isAdmin" checked={form.isAdmin} onChange={handleChange} className="w-5 h-5 accent-brand-primary" id="isAdminCheck" />
//               <label htmlFor="isAdminCheck" className="font-bold text-xs uppercase tracking-widest text-gray-600 cursor-pointer">{t('admin.users_page.make_admin')}</label>
//             </div>
//             {/* Master Admin & Super Admin options: only for users with master privileges */}
//             {isAdminWithMasterPrivileges && (
//               <>
//                 <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm border border-amber-100">
//                   <input type="checkbox" name="is_master_admin" checked={form.is_master_admin} onChange={handleChange} className="w-5 h-5 accent-amber-500" id="isMasterAdminCheck" />
//                   <label htmlFor="isMasterAdminCheck" className="font-bold text-[10px] uppercase tracking-widest text-amber-700 cursor-pointer">
//                     {t('admin.users_page.make_master_admin', 'Make Master Admin')}
//                   </label>
//                 </div>
//                 <div className="flex items-center gap-4 h-full bg-white px-4 rounded-xl shadow-sm border border-indigo-100">
//                   <input type="checkbox" name="is_super_admin" checked={form.is_super_admin} onChange={handleChange} className="w-5 h-5 accent-indigo-500" id="isSuperAdminCheck" />
//                   <label htmlFor="isSuperAdminCheck" className="font-bold text-[10px] uppercase tracking-widest text-indigo-700 cursor-pointer">
//                     {t('admin.users_page.make_super_admin', 'Make Super Admin')}
//                   </label>
//                 </div>
//               </>
//             )}
//           </form>
//           <button onClick={createUser} className="bg-brand-primary text-white px-8 py-4 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg shadow-brand-primary/20 hover:scale-105 active:scale-95 transition-all self-stretch md:self-auto h-[56px] flex items-center justify-center">
//             {t('admin.users_page.create_btn')}
//           </button>
//         </div>
//       </div>

//       <div className="flex justify-between items-center mb-6 gap-4">
//         <div className="relative flex-1 max-w-md">
//           <i className="fas fa-search absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
//           <input value={q} onChange={e => setQ(e.target.value)} placeholder={t('admin.common.search_placeholder', 'Search by username, email, or ID...')} className="w-full pl-12 pr-4 py-3 rounded-2xl border-none bg-gray-50 focus:bg-white focus:ring-2 focus:ring-brand-primary/20 transition-all font-medium" />
//         </div>


//       </div>

//       {message && <div className="mb-6 p-4 bg-blue-50 text-blue-800 rounded-2xl font-medium border border-blue-100 flex items-center gap-3"><i className="fas fa-info-circle"></i>{message}</div>}

//       {
//         loading ? <div className="p-12 text-center text-gray-500 font-medium animate-pulse">{t('admin.common.loading')}</div> : (
//           <div className="overflow-x-auto rounded-[30px] border border-gray-100 shadow-sm">
//             <table className="w-full text-left">
//               <thead className="bg-gray-50 border-b border-gray-100 text-gray-500">
//                 <tr>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.common.id')}</th>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_username', 'Username')}</th>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_fullname', 'Full Name')}</th>
//                   {hasPerm('users.email') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_email')}</th>}
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_phone', 'Phone')}</th>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_admin')} / Role</th>
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_permissions', 'Permissions')}</th>
//                   {isAdminWithMasterPrivileges && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_store_profile', 'Store Profile')}</th>}
//                   {hasPerm('users.created_at') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_created', 'Created')}</th>}
//                   {hasPerm('users.updated_at') && <th className="p-5 font-black uppercase text-[10px] tracking-widest">{t('admin.users_page.table_updated', 'Updated')}</th>}
//                   <th className="p-5 font-black uppercase text-[10px] tracking-widest text-right">{t('admin.common.actions', 'Actions')}</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {users.map(u => (
//                   <tr key={u.id} className="hover:bg-gray-50/80 transition-colors group">
//                     <td className="p-5 font-bold text-gray-600">#{u.id}</td>
//                     <td className="p-5">
//                       <div className="font-bold text-gray-900">{u.username}</div>
//                       <div className="text-[10px] text-gray-400 font-medium">@{u.username}</div>
//                     </td>
//                     <td className="p-5 font-medium text-gray-900">{u.fullname || <span className="text-gray-300 italic">None</span>}</td>
//                     {hasPerm('users.email') && <td className="p-5 font-medium text-gray-600">{u.email}</td>}
//                     <td className="p-5 font-bold text-brand-primary text-xs whitespace-nowrap">{u.phone || <span className="text-gray-300">—</span>}</td>
//                     <td className="p-5">
//                       {/* ROLE DIFFERENTIATION:
//                           - MASTER ADMIN (amber)  = has '*' AND (no profile / master profile) OR has '*' + 'master' marker on hostname profile
//                           - SUPER ADMIN (indigo)  = has '*' + hostname profile (no 'master' marker)
//                           - ADMIN (purple)         = isAdmin, no '*'
//                           - USER (gray)            = not admin
//                       */}
//                       {u.isAdmin ? (
//                         u.permissions && (u.permissions.includes('*') || u.permissions === '*') ? (
//                           // Hostname profile without 'master' marker = Super Admin
//                           u.profile_id && u.profile_id !== 'prof_01JK0000000000000000000001' && !u.permissions.includes('master') ? (
//                             <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-indigo-200">
//                               {t('admin.users_page.role_super_admin', 'SUPER ADMIN')}
//                             </span>
//                           ) : (
//                             // No profile / master profile / or hostname with 'master' marker = Master Admin
//                             <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border border-amber-200">
//                               {t('admin.users_page.role_master_admin', 'MASTER ADMIN')}
//                             </span>
//                           )
//                         ) : (
//                           <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
//                             {t('admin.users_page.role_admin', 'ADMIN')}
//                           </span>
//                         )
//                       ) : (
//                         <span className="bg-gray-100 text-gray-500 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
//                           {t('admin.users_page.role_user', 'USER')}
//                         </span>
//                       )}
//                     </td>
//                     <td className="p-5">
//                       {u.isAdmin &&
//                         <div className="text-xs text-gray-500">
//                           {u.permissions && (u.permissions.includes('*') || u.permissions === '*') ?
//                             <span className="text-brand-primary font-bold">{t('admin.users_page.full_access', 'Full Access')}</span> :
//                             (u.permissions?.length > 0 ? (Array.isArray(u.permissions) ? u.permissions.join(', ') : u.permissions) : t('admin.users_page.none', 'None'))
//                           }
//                         </div>
//                       }
//                     </td>
//                     {isAdminWithMasterPrivileges && (
//                       <td className="p-5">
//                         {u.profile_id ? (
//                           <div className="flex flex-col">
//                             <span className="text-xs font-bold bg-indigo-50 text-indigo-700 px-2 py-1 rounded-lg w-fit">
//                               {profiles.find(p => p.id === u.profile_id)?.name || `Profile #${u.profile_id}`}
//                             </span>
//                             <span className="text-[10px] text-gray-400 mt-1">{u.profile_id}</span>
//                           </div>
//                         ) : <span className="text-xs text-gray-400">—</span>}
//                       </td>
//                     )}
//                     {hasPerm('users.created_at') && <td className="p-5 text-xs text-gray-500 whitespace-nowrap">{formatDate(u.created_at)}</td>}
//                     {hasPerm('users.updated_at') && <td className="p-5 text-xs text-gray-500 whitespace-nowrap">{formatDate(u.updated_at)}</td>}
//                     <td className="p-5 text-right">
//                       <div className="flex gap-2 justify-end opacity-40 group-hover:opacity-100 transition-opacity">
//                         {u.isAdmin && (
//                           <button onClick={() => openPermissionModal(u)} className="w-8 h-8 rounded-full bg-blue-50 hover:bg-blue-500 hover:text-white text-blue-500 flex items-center justify-center transition-all" title={t('admin.users_page.edit_permissions', 'Edit Permissions')}>
//                             <i className="fas fa-key text-xs"></i>
//                           </button>
//                         )}
//                         <button onClick={() => toggleAdmin(u.id, !!u.isAdmin)} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-brand-primary hover:text-white text-gray-600 flex items-center justify-center transition-all" title={t('admin.users_page.toggle_role', 'Toggle Role')}>
//                           <i className="fas fa-user-shield text-xs"></i>
//                         </button>
//                         <button onClick={() => deleteUser(u.id)} className="w-8 h-8 rounded-full bg-red-50 hover:bg-red-500 hover:text-white text-red-500 flex items-center justify-center transition-all" title={t('admin.common.delete', 'Delete')}>
//                           <i className="fas fa-trash text-xs"></i>
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )
//       }
//       {
//         total > 50 && (
//           <div className="flex justify-center gap-4 items-center mt-8">
//             <button onClick={() => fetchUsers(Math.max(1, page - 1))} disabled={page <= 1} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center disabled:opacity-50 transition-all font-bold">{isArabic ? "→" : "←"}</button>
//             <div className="text-xs font-black uppercase tracking-widest text-gray-400">{t('admin.common.page', { current: page, total: Math.ceil(total / 50) })}</div>
//             <button onClick={() => fetchUsers(page + 1)} disabled={page >= Math.ceil(total / 50)} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center disabled:opacity-50 transition-all font-bold">{isArabic ? "←" : "→"}</button>
//           </div>
//         )
//       }

//       {/* Permission Modal */}
//       {editingUser && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
//           <div className="bg-white p-8 rounded-[30px] shadow-2xl max-w-lg w-full m-4">
//             <h3 className="text-xl font-bold mb-4">Edit — {editingUser.username}</h3>

//             <div className="grid grid-cols-2 gap-4 mb-6">
//               <div>
//                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_username', 'Username')}</label>
//                 <input
//                   value={editingUser.username || ''}
//                   onChange={e => setEditingUser({ ...editingUser, username: e.target.value })}
//                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
//                 />
//               </div>
//               <div>
//                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_fullname', 'Full Name')}</label>
//                 <input
//                   value={editingUser.fullname || ''}
//                   onChange={e => setEditingUser({ ...editingUser, fullname: e.target.value })}
//                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
//                 />
//               </div>
//               <div className="col-span-2">
//                 <label className="block text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1 ml-1">{t('admin.users_page.table_phone', 'Phone Number')}</label>
//                 <input
//                   value={editingUser.phone || ''}
//                   onChange={e => setEditingUser({ ...editingUser, phone: e.target.value })}
//                   className="w-full p-3 rounded-xl border border-gray-100 bg-gray-50 font-bold text-sm focus:ring-2 focus:ring-brand-primary/20 outline-none"
//                 />
//               </div>
//             </div>

//             {/* Assign to Store Profile: Only for main-store admins, hidden for hostname store admins */}
//             {isMainStoreAdmin && (
//               <div className="mb-6 p-4 bg-indigo-50 rounded-2xl border border-indigo-100">
//                 <label className="block text-xs font-black text-indigo-600 uppercase tracking-widest mb-2">🏪 {t('admin.users_page.assign_to_profile', 'Assign to Store Profile')}</label>
//                 <select
//                   value={editingUser.profile_id || ''}
//                   onChange={e => setEditingUser({ ...editingUser, profile_id: e.target.value })}
//                   className="w-full p-3 rounded-xl border border-indigo-200 bg-white font-medium text-sm focus:ring-2 focus:ring-indigo-300 outline-none"
//                 >
//                   <option value="">— {t('admin.users_page.no_profile_assigned', 'No profile assigned')} —</option>
//                   {profiles
//                     .filter(p => p.hostname !== null || p.id === 'prof_01JK0000000000000000000001' || p.name === "Main Store Pack" || p.id === editingUser.profile_id)
//                     .map(p => (
//                       <option key={p.id} value={p.id}>{p.name}{p.is_active ? ` ★ ${t('admin.users_page.primary', 'Primary')}` : ''}</option>
//                     ))
//                   }
//                 </select>
//                 <p className="text-[10px] text-indigo-400 mt-1 font-medium">{t('admin.users_page.profile_desc', 'This determines which isolated store this admin manages.')}</p>
//               </div>
//             )}

//             <div className="flex flex-col gap-2 mb-6 max-h-[40vh] overflow-y-auto">
//               {PERMISSION_OPTIONS.map(opt => {
//                 // Security: Hide profile assignment permission from non-Main-Store Admins
//                 if (opt.id === 'users.assign_profile' && !isMainStoreAdmin) return null;

//                 return (
//                   <React.Fragment key={opt.id}>
//                     {/* Visual separator before the Full Access option */}
//                     {opt.id === '*' && (
//                       <div className="my-2 border-t border-gray-100 pt-2" />
//                     )}
//                     <label className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer border transition-colors ${opt.id === '*' ? 'hover:bg-amber-50 hover:border-amber-200 border-transparent' : 'hover:bg-gray-50 border-transparent hover:border-gray-100'}`}>
//                       <input
//                         type="checkbox"
//                         checked={editingUser.permissions && editingUser.permissions.includes(opt.id)}
//                         onChange={() => handlePermissionChange(opt.id)}
//                         disabled={opt.id === '*' && editingUser.id === currentUserId}
//                         className={`w-5 h-5 ${opt.id === '*' ? 'accent-amber-500' : 'accent-brand-primary'} disabled:opacity-50 disabled:cursor-not-allowed`}
//                       />
//                       <span className={`font-medium ${opt.id === '*' ? 'text-amber-700' : 'text-gray-700'}`}>
//                         {opt.label}
//                       </span>
//                     </label>
//                   </React.Fragment>
//                 );
//               })}
//             </div>
//             <div className="flex gap-3 justify-end">
//               <button onClick={() => setEditingUser(null)} className="px-6 py-3 rounded-xl bg-gray-100 font-bold text-gray-600 hover:bg-gray-200">Cancel</button>
//               <button onClick={savePermissions} className="px-6 py-3 rounded-xl bg-brand-primary font-bold text-white hover:bg-brand-primary/90">Save</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div >
//   );
// });

// export default AdminUsers;

